import * as _ from "lodash"
import { Schema } from "js-data"
import * as PASchema from "./PAdbSchema"
import {
    dctLogicalKeysByEntitySet,
    dctMapperToKeyGenSpecs,
    dctNonParentForeignKeysByEntitySet,
    dctSchemaByEntitySet,
    dctTableNameByEntitySet,
    KeyGenSpecs_default,
    KeyGenSpecs_Poolsize_500
} from "./PAdbSchema"
import { IKeyGeneratorSpecs } from "./lib/libIF"

// MD Set
export const WB_MasterData_Set = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_MDSets", // optional
    description: "Schema for WB_MDSet records", // optional
    type: "object",
    track: true,
    properties: {
        WB_MDSET_ID: {
            type: "number",
            id: true,
            required: true
        },
        MDSET_ID: {
            type: "string",
            length: 50
        },
        MDSET_NAME: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})

export const WB_MasterData_Set_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Source]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "Sources" },
        [PASchema.esWB_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "Sets" },
        [PASchema.esWB_Division]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "Divisions" },
        [PASchema.esWB_DistribChannel]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "DistribChannels"
        },
        [PASchema.esWB_Company]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "Companies" }
    }
}

export const WB_Source = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Sources", // optional
    description: "Schema for Source records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SOURCE_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: "number"
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        SOURCE_NAME: {
            type: "string",
            length: 256
        },
        WB_SOURCETYPE_ID: {
            type: "number"
        },
        BUSINESS_CONTACT: {
            type: "string",
            length: 256
        },
        TECHNICAL_CONTACT: {
            type: "string",
            length: 256
        },
        SOURCE_URL: {
            type: "string",
            length: 256
        },
        WEEK_START_DAY_OF_WEEK: {
            type: "string",
            length: 20
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Source_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" }
    },
    hasMany: {
        [PASchema.esWB_Source_SetType]: {
            foreignKey: "WB_SOURCE_ID",
            foreignKeyImmutable: true,
            localField: "SourceSetTypes"
        }
    }
}

export const WB_Source_SetType = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Source Sets", // optional
    description: "Schema for SourceSR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SOURCESR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_SOURCE_ID: {
            type: "number"
        },
        SET_TYPE: {
            type: "string",
            length: 50
        },
        INTEGRATION_ALGORITHM: {
            type: "string",
            length: 50
        },
        WB_SET_ID: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Source_SetType_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Source]: { foreignKey: "WB_SOURCE_ID", foreignKeyImmutable: true, localField: "Source" }
    }
}

export const WB_Sets = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Sets", // optional
    description: "Schema for Sets records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SET_ID: {
            type: "number",
            id: true,
            required: true
        },
        SET_ID: {
            type: "string",
            length: 50
        },
        SET_TYPE: {
            type: "string",
            length: 50
        },
        SET_SUBTYPE: {
            type: "string",
            length: 50
        },
        WB_MDSET_ID: {
            type: "number"
        },
        SET_NAME: {
            type: "string",
            length: 256
        },
        USAGE_COUNT: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Sets_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" }
    }
}

export const WB_Division = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Divisions", // optional
    description: "Schema for WB_Division records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DIVISION_ID: {
            type: "number",
            id: true,
            required: true
        },
        DIVISION_ID: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        DIVISION_NAME: {
            type: "string",
            length: 256
        },
        WB_MDSET_ID: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Division_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" }
    },
    hasMany: {
        [PASchema.esWB_Division_Text]: {
            foreignKey: "WB_DIVISION_ID",
            foreignKeyImmutable: true,
            localField: "DivisionTexts"
        }
    }
}

export const WB_Division_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Division Texts", // optional
    description: "Schema for WB_DivisionT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DIVISIONT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_DIVISION_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },

        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Division_Text_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Division]: { foreignKey: "WB_DIVISION_ID", foreignKeyImmutable: true, localField: "Division" }
    }
}

export const WB_DistribChannel = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Distribution Channels", // optional
    description: "Schema for WB_DistribChannel records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DISTRIBCHANNEL_ID: {
            type: "number",
            id: true,
            required: true
        },
        DISTRIBCHANNEL_ID: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        DISTRIBCHANNEL_NAME: {
            type: "string",
            length: 256
        },
        WB_MDSET_ID: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_DistribChannel_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" }
    },
    hasMany: {
        [PASchema.esWB_DistribChannel_Text]: {
            foreignKey: "WB_DISTRIBCHANNEL_ID",
            foreignKeyImmutable: true,
            localField: "DistribChannelTexts"
        }
    }
}

export const WB_DistribChannel_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Distribution Channel Texts", // optional
    description: "Schema for WB_DistribChannelT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_DISTRIBCHANNELT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_DISTRIBCHANNEL_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },

        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_DistribChannel_Text_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_DistribChannel]: {
            foreignKey: "WB_DISTRIBCHANNEL_ID",
            foreignKeyImmutable: true,
            localField: "DistribChannel"
        }
    }
}

export const WB_Company = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Companys", // optional
    description: "Schema for WB_Company records", // optional
    type: "object",
    track: true,
    properties: {
        WB_COMPANY_ID: {
            type: "number",
            id: true,
            required: true
        },
        COMPANY_ID: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        COMPANY_NAME: {
            type: "string",
            length: 256
        },
        WB_MDSET_ID: {
            type: "number"
        },
        CITY: {
            type: "string",
            length: 50
        },
        COUNTRY: {
            type: "string",
            length: 50
        },
        WB_CURRENCY_ID: {
            type: "number"
        },
        WB_GL_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        WB_PERIODH_ID: {
            type: "number"
        },
        PARENT_COMPANY_ID: {
            type: "string",
            length: 50
        },
        GL_INTERFACE_POSTING_MODE: {
            type: "string",
            length: 50
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Company_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" },
        [PASchema.esWB_Currency]: {
            foreignKey: "WB_CURRENCY_ID",
            foreignKeyImmutable: true,
            localField: "localCurrency"
        },
        [PASchema.esWB_General_Ledger]: {
            foreignKey: "WB_GL_ID",
            foreignKeyImmutable: true,
            localField: "GeneralLedger"
        }
    },
    hasMany: {
        [PASchema.esWB_SalesOrg]: { foreignKey: "WB_COMPANY_ID", foreignKeyImmutable: true, localField: "SalesOrgs" },
        [PASchema.esWB_Company_Text]: {
            foreignKey: "WB_COMPANY_ID",
            foreignKeyImmutable: true,
            localField: "CompanyTexts"
        }
    }
}

export const WB_Company_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Company Texts", // optional
    description: "Schema for WB_CompanyT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_COMPANYT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_COMPANY_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },
        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Company_Text_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Company]: { foreignKey: "WB_COMPANY_ID", foreignKeyImmutable: true, localField: "Company" }
    }
}

export const WB_SalesOrg = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SalesOrgs", // optional
    description: "Schema for WB_SalesOrg records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SALESORG_ID: {
            type: "number",
            id: true,
            required: true
        },
        SALESORG_ID: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        SALESORG_NAME: {
            type: "string",
            length: 256
        },
        WB_COMPANY_ID: {
            type: "number"
        },
        WB_PRICINGENGINE_ID: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_SalesOrg_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Company]: { foreignKey: "WB_COMPANY_ID", foreignKeyImmutable: true, localField: "Company" }
    },
    hasMany: {
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "SalesAreas"
        },
        [PASchema.esWB_SalesOrg_Text]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "SalesOrgTexts"
        },
        [PASchema.esWB_Customer_External_Relationship]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "ExternalCustomers"
        },
        [PASchema.esWB_Customer_Calendar]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "CustomerCalendars"
        },
        [PASchema.esWB_LiftAPI]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "LiftAPIs"
        },
        [PASchema.esWB_Benchmark]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "Benchmarks"
        },
        [PASchema.esWB_Target]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "Targets"
        }
    }
}

export const WB_SalesOrg_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SalesOrg Texts", // optional
    description: "Schema for WB_SalesOrgT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SALESORGT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_SALESORG_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },
        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_SalesOrg_Text_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_SalesOrg]: { foreignKey: "WB_SALESORG_ID", foreignKeyImmutable: true, localField: "SalesOrg" }
    }
}

export const WB_SalesArea = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SalesAreas", // optional
    description: "Schema for WB_SalesArea records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SALESAREA_ID: {
            type: "number",
            id: true,
            required: true
        },
        SALESAREA_ID: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        SALESAREA_NAME: {
            type: "string",
            length: 256
        },
        WB_SALESORG_ID: {
            type: "number"
        },
        WB_DIVISION_ID: {
            type: "number"
        },
        WB_DISTRIBCHANNEL_ID: {
            type: "number"
        },
        BUSINESS_AREA_ID: {
            type: "string",
            length: 50
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_SalesArea_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_SalesOrg]: { foreignKey: "WB_SALESORG_ID", foreignKeyImmutable: true, localField: "SalesOrg" },
        [PASchema.esWB_Division]: { foreignKey: "WB_DIVISION_ID", foreignKeyImmutable: true, localField: "Division" },
        [PASchema.esWB_DistribChannel]: {
            foreignKey: "WB_DISTRIBCHANNEL_ID",
            foreignKeyImmutable: true,
            localField: "DistribChannel"
        }
    },
    hasMany: {
        [PASchema.esWB_SalesArea_Text]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesAreaTexts"
        }
    }
}

export const WB_SalesArea_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "SalesArea Texts", // optional
    description: "Schema for WB_SalesAreaT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SALESAREAT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },
        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_SalesArea_Text_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        }
    }
}

// Customer Hierarchy
export const WB_Customer_Hierarchy = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_Hierarchy", // optional
    description: "Schema for WB_CustH records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTH_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_HIER_ID: {
            type: "string",
            length: 50
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0
        },
        WB_CUST_HIER_NAME: {
            type: "string",
            length: 256
        },
        CUSTOMER_HIERARCHY_TYPE: {
            type: "string",
            length: 50
        },
        HIERARCHY_USAGE: {
            type: "string",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        SALESORG: {
            type: "string",
            length: 20
        },
        DISTRIBCHANNEL: {
            type: "string",
            length: 20
        },
        DIVISION: {
            type: "string",
            length: 20
        },
        TPM_BPA_HIER_TREE_ROW_ID: {
            type: "string",
            length: 50
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            default: "",
            length: 1
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Customer_Hierarchy_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        }
    },
    hasMany: {
        [PASchema.esWB_Customer_Hierarchy_Level]: {
            foreignKey: "WB_CUSTH_ID",
            foreignKeyImmutable: true,
            localField: "CustomerHierarchyLevel"
        },
        [PASchema.esWB_Customer_Hierarchy_SalesArea]: {
            foreignKey: "WB_CUSTH_ID",
            foreignKeyImmutable: true,
            localField: "SalesAreas"
        }
    }
}

export const WB_Customer_Hierarchy_SalesArea = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_Hierarchy_SalesArea", // optional
    description: "Schema for WB_CustomerHSR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTHSR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUSTH_ID: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        SALESORG: {
            type: "string",
            length: 50
        },
        DIVISION: {
            type: "string",
            length: 50
        },
        DISTRIBCHANNEL: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Hierarchy_SalesArea_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer_Hierarchy]: {
            foreignKey: "WB_CUSTH_ID",
            foreignKeyImmutable: true,
            localField: "CustomerHierarchy"
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        }
    }
}

export const WB_Customer_Hierarchy_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_Hierarchy_Text", // optional
    description: "Schema for WB_CustHT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTHT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUSTH_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },
        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Hierarchy_Text_JSData_RELs = {}
// Customer Hierarchy Level
export const WB_Customer_Hierarchy_Level = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_Hierarchy_Level", // optional
    description: "Schema for WB_CustH_Level records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTH_LEVEL_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUSTH_ID: {
            type: "number"
        },
        LEVEL_DEPTH: {
            type: "number"
        },
        LEVEL_ID: {
            type: "string",
            length: 50
        },
        LEVEL_NAME: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Customer_Hierarchy_Level_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer_Hierarchy]: {
            foreignKey: "WB_CUSTH_ID",
            foreignKeyImmutable: true,
            localField: "CustomerHierarchy"
        }
    }
}

//Customer
export const WB_Customer = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer", // optional
    description: "Schema for WB_Cust records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUST_ID: {
            type: "number",
            id: true,
            required: true
        },
        CUSTOMER_ID: {
            type: "string",
            default: "",
            length: 50
        },
        CUSTOMER_SET_ID: {
            type: "string",
            default: "",
            length: 50
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0
        },
        CUSTOMER_NAME: {
            type: "string",
            default: "",
            length: 256
        },
        CUSTOMER_NAME_2: {
            type: "string",
            default: "",
            length: 256
        },
        CUSTOMER_TYPE: {
            type: "string",
            default: "",
            length: 50
        },
        STATUS_CODE: {
            type: "string",
            default: "",
            length: 50
        },
        COMPANY_CODE: {
            type: "string",
            default: "",
            length: 50
        },
        CONSUMPTION_IND: {
            type: "string",
            default: "",
            length: 1
        },
        SHIPMENT_IND: {
            type: "string",
            default: "",
            length: 1
        },
        PLANNING_CUSTOMER_IND: {
            type: "string",
            default: "",
            length: 1
        },
        PLANNED_PERIODS: {
            type: "string",
            default: "",
            length: 256
        },
        TERRITORY_IND: {
            type: "string",
            default: "",
            length: 1
        },
        TREE_PATH: {
            type: "string",
            default: "",
            length: 256
        },
        CITY: {
            type: "string",
            default: "",
            length: 50
        },
        ADDRESS: {
            type: "string",
            default: "",
            length: 50
        },
        POSTAL_CODE: {
            type: "string",
            default: "",
            length: 20
        },
        COUNTRY_CODE: {
            type: "string",
            length: 20
        },
        REGIONAL_MARKET: {
            type: "string",
            default: "",
            length: 50
        },
        CUSTOMER_CLASSIFICATION: {
            type: "string",
            default: "",
            length: 50
        },
        ACCOUNT_GROUP: {
            type: "string",
            default: "",
            length: 50
        },
        INDUSTRY_CODE1: {
            type: "string",
            default: "",
            length: 50
        },
        INDUSTRY_CODE2: {
            type: "string",
            default: "",
            length: 50
        },
        INDUSTRY_CODE3: {
            type: "string",
            default: "",
            length: 50
        },
        WB_SOURCE_ID: {
            type: "number",
            default: 0
        },
        SOURCE_ID: {
            type: "string",
            default: "",
            length: 50
        },
        VAT_LIABLE_IND: {
            type: "string",
            default: "",
            length: 1
        },
        PAYMENT_BLOCK_IND: {
            type: "string",
            default: "",
            length: 1
        },
        CENTRAL_POSTING_BLOCK: {
            type: "string",
            default: "",
            length: 50
        },
        CENTRAL_PURCHASING_BLOCK: {
            type: "string",
            default: "",
            length: 50
        },
        ORDER_BLOCK: {
            type: "string",
            default: "",
            length: 50
        },
        BILLING_BLOCK: {
            type: "string",
            default: "",
            length: 50
        },
        EXT_DELETION_IND: {
            type: "string",
            default: "",
            length: 1
        },
        HIER_NODE_IND: {
            type: "string",
            default: "",
            length: 1
        },
        MANUAL_IND: {
            type: "string",
            default: "",
            length: 1
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        },
        [PASchema.esWB_Source]: { foreignKey: "WB_SOURCE_ID", foreignKeyImmutable: true, localField: "Source" }
    },
    hasMany: {
        [PASchema.esWB_Customer_Relationship]: [
            { foreignKey: "WB_CUST_ID_PRNT", foreignKeyImmutable: true, localField: "Children" },
            { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Parents" }
        ],
        [PASchema.esWB_Customer_Attribute]: {
            foreignKey: "WB_CUST_ID",
            foreignKeyImmutable: true,
            localField: "CustomerAttributes"
        },
        [PASchema.esWB_Customer_LogicalKey]: {
            foreignKey: "WB_CUST_ID",
            foreignKeyImmutable: true,
            localField: "CustomerLogicalKeys"
        },
        [PASchema.esWB_Customer_Distribution_Relationship]: {
            foreignKey: "WB_CUST_ID",
            foreignKeyImmutable: true,
            localField: "CustomerDistribution"
        },
        [PASchema.esWB_Customer_Tag_Relationship]: {
            foreignKey: "WB_CUST_ID",
            foreignKeyImmutable: true,
            localField: "CustomerTags"
        },
        [PASchema.esWB_Customer_SalesArea_Relationship]: {
            foreignKey: "WB_CUST_ID",
            foreignKeyImmutable: true,
            localField: "CustomerSalesAreas"
        },
        [PASchema.esWB_Customer_Role_Relationship]: {
            foreignKey: "WB_CUST_ID",
            foreignKeyImmutable: true,
            localField: "CustomerRoles"
        },
        [PASchema.esWB_Customer_Bill_To_Relationship]: [
            { foreignKey: "WB_CUST_ID_PLANNING", foreignKeyImmutable: true, localField: "BillToRelationships" },
            {
                foreignKey: "WB_CUST_ID_SUBPLANNING",
                foreignKeyImmutable: true,
                localField: "SubPlanningBillToRelationships"
            }
        ],
        [PASchema.esWB_Customer_Pay_To_Relationship]: [
            { foreignKey: "WB_CUST_ID_PLANNING", foreignKeyImmutable: true, localField: "PayToRelationships_Planning" },
            { foreignKey: "WB_CUST_ID_PAYTO", foreignKeyImmutable: true, localField: "PayToRelationships_PayTo" }
        ],
        [PASchema.esWB_Customer_Role_Customer_Relationship]: [
            { foreignKey: "WB_CUST_ID_REL", foreignKeyImmutable: true, localField: "RoleProvidedBy" },
            { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "RoleProvidedTo" }
        ]
    }
}

export const WB_Customer_Attribute = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_Attribute", // optional
    description: "Schema for WB_CustAttr records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTATTR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID: {
            type: "number",
            default: 0
        },
        WB_ATTRIBUTEM_ID: {
            type: "number",
            default: 0
        },
        WB_SALESAREA_ID: {
            type: "number",
            default: 0
        },
        ENTITY_ID_UI: {
            type: "string",
            default: "",
            length: 50
        },
        ENTITY_KEYSET: {
            type: "string",
            default: "",
            length: 20
        },
        VALUE_WB_ID: {
            type: "number",
            default: 0
        },

        VALUE_STRING: {
            type: "string",
            default: "",
            length: 256
        },
        VALUE_NUMBER: {
            type: "number",
            default: 0
        },
        SOURCE_ID: {
            type: "string",
            default: "",
            length: 50
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Attribute_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
        [PASchema.esWB_AttributeType]: {
            foreignKey: "WB_ATTRIBUTEM_ID",
            foreignKeyImmutable: true,
            localField: "AttributeType"
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        }
    }
}

export const WB_Customer_LogicalKey = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_LogicalKey", // optional
    description: "Schema for WB_CustLKR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTLKR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID: {
            type: "number",
            default: 0
        },
        KEY_ID: {
            type: "string",
            default: "",
            length: 50
        },
        DATATYPE: {
            type: "string",
            default: "",
            length: 50
        },
        VALUE_WB_ENTITY_ID: {
            type: "number",
            default: 0
        },
        VALUE_WB_ID: {
            type: "number",
            default: 0
        },
        VALUE_WB_ATTRIBUTEM_ID: {
            type: "number",
            default: 0
        },
        VALUE_STRING: {
            type: "string",
            default: "",
            length: 256
        },
        VALUE_NUMBER: {
            type: "number",
            default: 0
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_LogicalKey_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" }
    }
}

export const WB_Customer_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_Relationship", // optional
    description: "Schema for WB_CustR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUSTH_ID: {
            type: "number"
        },
        WB_CUST_ID: {
            type: "number"
        },
        WB_CUST_ID_PRNT: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        SOURCE_KEY: {
            type: "string",
            length: 100
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer_Hierarchy]: {
            foreignKey: "WB_CUSTH_ID",
            foreignKeyImmutable: true,
            localField: "Hierarchy"
        },
        [PASchema.esWB_Customer]: [
            {
                foreignKey: "WB_CUST_ID_PRNT",
                foreignKeyImmutable: true,
                localField: "Parent",
                createIndex: true
            },
            { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Child", createIndex: true }
        ]
    }
}

export const WB_Customer_Tag_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_Tag_Relationship", // optional
    description: "Schema for WB_Cust_TagR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUST_TAGR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID: {
            type: "number"
        },
        WB_TAG_ID: {
            type: "number"
        },
        TAG_METHOD: {
            type: "string",
            length: 50
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Tag_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Tag]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Tag" },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" }
    }
}

export const WB_Customer_External_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_External_Relationship", // optional
    description: "Schema for WB_ExtCustR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EXTCUSTR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID_SOURCE: {
            type: "number"
        },
        WB_SALESORG_ID: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        EXTERNAL_CUSTOMER_ID: {
            type: "string",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        PRODUCT_ORG_DIVISION: {
            type: "string",
            length: 50
        },
        WB_CUST_ID_PLANNING: {
            type: "number"
        },
        COVERAGE_FACTOR: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_External_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: [
            {
                foreignKey: "WB_CUST_ID_PLANNING",
                foreignKeyImmutable: true,
                localField: "PlanningCustomer"
            },
            { foreignKey: "WB_CUST_ID_SOURCE", foreignKeyImmutable: true, localField: "ExternalCustomer" }
        ],

        [PASchema.esWB_SalesOrg]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "SalesOrg"
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        }
    }
}

export const WB_Customer_Proxy_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_Proxy_Relationship", // optional
    description: "Schema for WB_ExtCustP records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EXTCUSTP_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID_SOURCE: {
            type: "number"
        },
        WB_CUST_ID_PROXY: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        }
    }
})
export const WB_Customer_Proxy_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: [
            { foreignKey: "WB_CUST_ID_SOURCE", foreignKeyImmutable: true, localField: "SourceCustomer" },
            { foreignKey: "WB_CUST_ID_PROXY", foreignKeyImmutable: true, localField: "ProxyCustomer" }
        ]
    }
}

export const WB_Customer_Calendar = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CustCal", // optional
    description: "Schema for WB_CustCal records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTCAL_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_SALESORG_ID: {
            type: "number"
        },
        WB_SOURCE_ID: {
            type: "number"
        },
        WB_CUST_ID: {
            type: "number"
        },
        RETAIL_CALENDAR_START: {
            type: "string",
            length: 20
        },
        CONSUMPTION_PERIOD_LEVEL_ID: {
            type: "string",
            length: 20
        },
        CONSUMPTION_DAY_OFFSET: {
            type: "number"
        },
        SHIPMENT_IND_PERIOD_LEVEL_ID: {
            type: "string",
            length: 20
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        CONSUMPTION_ALIGNED_IND: {
            type: "string",
            length: 1
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        WEEK_START_DAY_OF_WEEK_ACT: {
            type: "string",
            length: 20
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Calendar_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
        [PASchema.esWB_SalesOrg]: { foreignKey: "WB_SALESORG_ID", foreignKeyImmutable: true, localField: "SalesOrg" },
        [PASchema.esWB_Source]: { foreignKey: "WB_SOURCE_ID", foreignKeyImmutable: true, localField: "Source" }
    }
}

export const WB_Customer_Bill_To_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Cust_Bill_To_Rel", // optional
    description: "Schema for WB_Cust_Bill_To_Rel records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUST_BILL_TO_REL_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID_PLANNING: {
            type: "number"
        },
        PLANNING_ACCOUNT_ID: {
            type: "string",
            length: 100
        },
        PLANNING_ACCOUNT_NAME: {
            type: "string",
            length: 100
        },
        WB_CUST_ID_SUBPLANNING: {
            type: "number"
        },
        SUBPLANNING_ACCOUNT_ID: {
            type: "string",
            length: 100
        },
        SUBPLANNING_ACCOUNT_NAME: {
            type: "string",
            length: 100
        },
        WB_CUST_ID_BILLTO: {
            type: "number"
        },
        BILL_TO_ID: {
            type: "string",
            length: 100
        },
        BILL_TO_NAME: {
            type: "string",
            length: 100
        },
        WB_CUST_ID_SHIPTO: {
            type: "number"
        },
        SHIP_TO_ID: {
            type: "string",
            length: 100
        },
        SHIP_TO_NAME: {
            type: "string",
            length: 100
        },
        VALID_FROM: {
            type: "string",
            default: "18000101",
            length: 8
        },
        VALID_THRU: {
            type: "string",
            default: "99991231",
            length: 8
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Bill_To_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: [
            { foreignKey: "WB_CUST_ID_PLANNING", foreignKeyImmutable: true, localField: "PlanningCustomer" },
            { foreignKey: "WB_CUST_ID_SUBPLANNING", foreignKeyImmutable: true, localField: "SubPlanningCustomer" },
            { foreignKey: "WB_CUST_ID_BILLTO", foreignKeyImmutable: true, localField: "BillToCustomer" },
            { foreignKey: "WB_CUST_ID_SHIPTO", foreignKeyImmutable: true, localField: "ShipToCustomer" }
        ]
    }
}

export const WB_Customer_Pay_To_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Cust_Pay_To_Rel", // optional
    description: "Schema for WB_Cust_Pay_To_Rel records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUST_PAY_TO_REL_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID_PLANNING: {
            type: "number"
        },
        WB_CUST_ID_PAYTO: {
            type: "number"
        },
        ACTIVE_IND: {
            type: "string",
            default: "1",
            length: 1
        },
        VALID_FROM: {
            type: "string",
            default: "18000101",
            length: 8
        },
        VALID_THRU: {
            type: "string",
            default: "99991231",
            length: 8
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Pay_To_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: [
            { foreignKey: "WB_CUST_ID_PLANNING", foreignKeyImmutable: true, localField: "PlanningCustomer" },
            { foreignKey: "WB_CUST_ID_PAYTO", foreignKeyImmutable: true, localField: "PayToCustomer" }
        ]
    }
}

export const WB_Customer_Product = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_Products", // optional
    description: "Schema for WB_CustPrdR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTPROD_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID: {
            type: "number"
        },
        WB_PROD_ID: {
            type: "number"
        },
        CONSUMER_PRODUCT_UPC: {
            type: "string",
            length: 50
        },
        WB_SOURCE_ID: {
            type: "number"
        },
        SALESORG: {
            type: "string",
            length: 20
        },
        CONS_DT_FIRST: {
            type: "string",
            length: 8
        },
        CONS_DT_LAST: {
            type: "string",
            length: 8
        },
        CONS_UNITS: {
            type: "number"
        },
        CONS_RTLSLS: {
            type: "number"
        },
        CONS_UPDATED: {
            type: "string",
            length: 8
        },
        SHIP_DT_FIRST: {
            type: "string",
            length: 8
        },
        SHIP_DT_LAST: {
            type: "string",
            length: 8
        },
        SHIP_QTY: {
            type: "number"
        },
        SHIP_UNITS: {
            type: "number"
        },
        SHIP_LISTSLS: {
            type: "number"
        },
        SHIP_UPDATED: {
            type: "string",
            length: 8
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        NOTES: {
            type: "string",
            length: 1333
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EXCLUDE_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Customer_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product"
        },
        [PASchema.esWB_Source]: { foreignKey: "WB_SOURCE_ID", foreignKeyImmutable: true, localField: "Source" }
    }
}

export const WB_Customer_Distribution_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_Distribution_Relationship", // optional
    description: "Schema for WB_CustRPG records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTRPG_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID: {
            type: "number"
        },
        WB_CUST_ID_REL: {
            type: "number"
        },
        WB_PRDGRP_ID: {
            type: "number"
        },
        RELATIONTYPE: {
            type: "string",
            length: 50
        },
        RATE: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        WB_FK_ROW_ID: {
            type: "string",
            length: 100
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Customer_Distribution_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: [
            {
                foreignKey: "WB_CUST_ID",
                foreignKeyImmutable: true,
                localField: "Customer"
            },
            { foreignKey: "WB_CUST_ID_REL", foreignKeyImmutable: true, localField: "CustomerRelated" }
        ],
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup"
        }
    }
}

export const WB_Customer_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CustM", // optional
    description: "Schema for WB_CustM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTM_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0
        },
        CUSTM_ID: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            default: "",
            length: 50
        },
        WB_ENTITY_ID: {
            type: "number",
            default: 0
        },
        KEY_SET_TYPE: {
            type: "string",
            length: 50
        },
        CUSTM_NAME: {
            type: "string",
            length: 256
        },

        ADDRESS_SHOW_IND: {
            type: "string",
            length: 1
        },
        ADDRESS_SEARCHABLE_IND: {
            type: "string",
            length: 1
        },

        SALESAREA_SHOW_IND: {
            type: "string",
            length: 1
        },
        SALESAREA_SEARCHABLE_IND: {
            type: "string",
            length: 1
        },

        STATUS_SHOW_IND: {
            type: "string",
            length: 1
        },
        STATUS_SEARCHABLE_IND: {
            type: "string",
            length: 1
        },

        SHOW_BILLTO_IND: {
            type: "string",
            length: 1
        },

        SHOW_PAYTO_IND: {
            type: "string",
            length: 1
        },

        HEADER_SHOW_FIELDS: {
            type: "string",
            length: 1333
        },

        HEADER_SEARCH_FIELDS: {
            type: "string",
            length: 1333
        },

        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Type_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        },
        [PASchema.esWB_Entity]: { foreignKey: "WB_ENTITY_ID", foreignKeyImmutable: true, localField: "Entity" }
    }
}

export const WB_Customer_Role = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CustRole", // optional
    description: "Schema for WB_CustRole records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTROLE_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            default: "",
            length: 50
        },
        ROLE_ID: {
            type: "string",
            default: "",
            length: 50
        },
        WB_CUSTM_ID: {
            type: "number",
            default: 0
        },
        ROLE_NAME: {
            type: "string",
            default: "",
            length: 256
        },
        SOURCE_ID: {
            type: "string",
            default: "",
            length: 50
        },
        SOURCE_ROLE_TYPE: {
            type: "string",
            default: "",
            length: 50
        },
        ALLOW_CREATE_IND: {
            type: "string",
            default: "",
            length: 1
        },
        MANUAL_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DEFAULT_IND: {
            type: "string",
            default: "",
            length: 1
        },
        VENDOR_IND: {
            type: "string",
            default: "",
            length: 1
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Role_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        },
        [PASchema.esWB_Customer_Type]: {
            foreignKey: "WB_CUSTM_ID",
            foreignKeyImmutable: true,
            localField: "CustomerType"
        }
    }
}

export const WB_Customer_SalesArea = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CustRole", // optional
    description: "Schema for WB_CustSR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTSR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        SALESORG: {
            type: "string",
            length: 50
        },
        DIVISION: {
            type: "string",
            length: 50
        },
        DISTRIBCHANNEL: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        CUSTOMER_CURRENCY: {
            type: "string",
            length: 50
        },
        EXCHANGE_RATE_TYPE: {
            type: "string",
            length: 50
        },
        WB_EXCHANGERATEM_ID: {
            type: "number"
        },
        PRICE_GROUP: {
            type: "string",
            length: 50
        },
        PRICE_LIST_TYPE: {
            type: "string",
            length: 50
        },
        STATUS_FLAG: {
            type: "string",
            length: 50
        },
        CUSTOMER_GROUP1: {
            type: "string",
            length: 50
        },
        CUSTOMER_GROUP2: {
            type: "string",
            length: 50
        },
        CUSTOMER_GROUP3: {
            type: "string",
            length: 50
        },
        CUSTOMER_GROUP4: {
            type: "string",
            length: 50
        },
        CUSTOMER_GROUP5: {
            type: "string",
            length: 50
        },
        ORDER_BLOCK: {
            type: "string",
            length: 50
        },
        BILLING_BLOCK: {
            type: "string",
            length: 50
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_SalesArea_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        }
    }
}

export const WB_Customer_Role_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CustRole", // optional
    description: "Schema for WB_CustSR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTRSR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID: {
            type: "number"
        },
        ROLE_ID: {
            type: "string",
            length: 50
        },
        WB_CUSTROLE_ID: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        SALESORG: {
            type: "string",
            length: 50
        },
        DIVISION: {
            type: "string",
            length: 50
        },
        DISTRIBCHANNEL: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        SOURCE_KEY: {
            type: "string",
            length: 100
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Role_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        },
        [PASchema.esWB_Customer_Role]: {
            foreignKey: "WB_CUSTROLE_ID",
            foreignKeyImmutable: true,
            localField: "CustomerRole"
        }
    }
}

export const WB_Customer_Role_Customer_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CustRSCR", // optional
    description: "Schema for WB_CustRSCR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTRSCR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID: {
            type: "number"
        },
        ROLE_ID: {
            type: "string",
            length: 50
        },
        WB_CUSTROLE_ID: {
            type: "number"
        },
        WB_CUST_ID_REL: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        SALESORG: {
            type: "string",
            length: 50
        },
        DIVISION: {
            type: "string",
            length: 50
        },
        DISTRIBCHANNEL: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        SOURCE_KEY: {
            type: "string",
            length: 100
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Customer_Role_Customer_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: [
            { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
            { foreignKey: "WB_CUST_ID_REL", foreignKeyImmutable: true, localField: "CustomerRel" }
        ],
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        },
        [PASchema.esWB_Customer_Role]: {
            foreignKey: "WB_CUSTROLE_ID",
            foreignKeyImmutable: true,
            localField: "CustomerRole"
        }
    }
}

export const WB_CustomerCR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CustCR", // optional
    description: "Schema for WB_CustCR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTCR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID: {
            type: "number"
        },
        WB_COMPANY_ID: {
            type: "number"
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        COMPANY_CODE: {
            type: "string",
            length: 50
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_CustomerCR_JSData_RELs = {}

export const WB_CustomerSAR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CustSAR", // optional
    description: "Schema for WB_CustSAR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CUSTSAR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUSTH_ID: {
            type: "number"
        },
        WB_CUST_ID: {
            type: "number"
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        SALESORG: {
            type: "string",
            length: 50
        },
        DIVISION: {
            type: "string",
            length: 50
        },
        DISTRIBCHANNEL: {
            type: "string",
            length: 50
        },
        WB_CUST_ID_PRNT: {
            type: "number"
        },
        WB_SALESAREA_ID_PRNT: {
            type: "number"
        },
        SALESORG_PRNT: {
            type: "string",
            length: 50
        },
        DIVISION_PRNT: {
            type: "string",
            length: 50
        },
        DISTRIBCHANNEL_PRNT: {
            type: "string",
            length: 50
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        SOURCE_KEY: {
            type: "string",
            length: 100
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_CustomerSAR_JSData_RELs = {}
// SourceType

export const WB_SourceType = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_SourceType", // optional
    description: "Schema for WB_SourceType records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SOURCETYPE_ID: {
            type: "number",
            id: true,
            required: true
        },
        SOURCE_TYPE_ID: {
            type: "string",
            length: 50
        },
        SOURCE_TYPE_NAME: {
            type: "string",
            length: 256
        },
        SYSTEM_TYPE: {
            type: "string",
            length: 50
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_SourceType_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_SourceTypeSTR]: {
            foreignKey: "WB_SOURCETYPE_ID",
            foreignKeyImmutable: true,
            localField: "SourceTypeStr"
        }
    }
}

export const WB_SourceTypeSTR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_SourceTypeSTR", // optional
    description: "Schema for WB_SourceTypeSTR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_SOURCETYPESTR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_SOURCETYPE_ID: {
            type: "number",
            id: true
        },
        SET_TYPE: {
            type: "string",
            length: 256,
            id: 2
        },
        INTEGRATION_ALGORITHMS: {
            type: "string",
            length: 500
        },
        COMMENTS: {
            type: "string",
            length: 1333
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_SourceTypeSTR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_SourceType]: {
            foreignKey: "WB_SOURCETYPE_ID",
            foreignKeyImmutable: true,
            localField: "SourceType"
        }
    }
}

// Product
export const WB_Finished_Product = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Prod", // optional
    description: "Schema for WB_Prod records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PROD_ID: {
            type: "number",
            id: true,
            required: true
        },
        PRODUCT_ID: {
            type: "string",
            default: "",
            length: 50
        },
        PRODUCT_SET_ID: {
            type: "string",
            default: "",
            length: 50
        },
        WB_MDSET_ID: {
            type: "number",
            default: "0"
        },
        WB_PROD_TYPE_ID: {
            type: "string",
            default: "",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            default: "",
            length: 50
        },
        PRODUCT_NAME: {
            type: "string",
            default: "",
            length: 256
        },
        WB_PRDM_ID: {
            type: "number",
            default: 0
        },
        PRODUCT_TYPE: {
            type: "string",
            default: "",
            length: 50
        },
        PRODUCT_SUBTYPE: {
            type: "string",
            default: "",
            length: 50
        },
        STATUS_CODE: {
            type: "string",
            default: "",
            length: 50
        },
        DISCONTINUED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        WB_DIVISION_ID: {
            type: "number",
            default: 0
        },
        PRODH: {
            type: "string",
            default: "",
            length: 50
        },
        PRODUCT_UPC: {
            type: "string",
            default: "",
            length: 50
        },
        CONSUMER_PRODUCT_UPC: {
            type: "string",
            default: "",
            length: 50
        },
        WB_PROD_ID_CNSPRD_UPC: {
            type: "number",
            default: 0
        },
        MANUFACTURER_ID: {
            type: "string",
            default: "",
            length: 50
        },
        GTIN: {
            type: "string",
            default: "",
            length: 50
        },
        BRAND_ID: {
            type: "string",
            default: "",
            length: 50
        },
        BASE_UOM: {
            type: "string",
            default: "",
            length: 20
        },
        ORDER_UOM: {
            type: "string",
            default: "",
            length: 20
        },
        CASE_PACK_SIZE: {
            type: "number",
            default: 0
        },
        STAT_CS_FACTOR: {
            type: "number",
            default: 0
        },
        WEIGHT_FACTOR: {
            type: "number",
            default: 0
        },
        NET_WEIGHT: {
            type: "number",
            default: 0
        },
        GROSS_WEIGHT: {
            type: "number",
            default: 0
        },
        WEIGHT_UOM: {
            type: "string",
            default: "",
            length: 20
        },
        UNIT_SIZE: {
            type: "number",
            default: 0
        },
        UNIT_UOM: {
            type: "string",
            default: "",
            length: 20
        },
        VOLUME_SIZE: {
            type: "number",
            default: 0
        },
        VOLUME_UOM: {
            type: "string",
            default: "",
            length: 20
        },
        NET_CONTENTS: {
            type: "number",
            default: 0
        },
        CONTENT_UOM: {
            type: "string",
            default: "",
            length: 20
        },
        SUB_BRAND: {
            type: "string",
            default: "",
            length: 50
        },
        TREE_PATH: {
            type: "string",
            default: "",
            length: 256
        },
        MANUAL_IND: {
            type: "string",
            default: "",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            default: "",
            length: 1
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Finished_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Type]: {
            foreignKey: "WB_PRDM_ID",
            foreignKeyImmutable: true,
            localField: "ProductType"
        },
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        }
    },
    hasMany: {
        [PASchema.esWB_Finished_Product_SalesArea]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "SalesAreas"
        },
        [PASchema.esWB_Finished_Product_Relationship]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroups"
        },
        [PASchema.esWB_Product_BOM]: { foreignKey: "WB_PROD_ID", foreignKeyImmutable: true, localField: "ProductBOMs" },
        [PASchema.esWB_Product_UOM]: { foreignKey: "WB_PROD_ID", foreignKeyImmutable: true, localField: "ProductUOMs" },
        [PASchema.esWB_Finished_Product_Tag_Relationship]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "ProdTags"
        },
        [PASchema.esWB_Product_Attribute]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "ProductAttributes"
        }
    }
}

export const WB_Finished_Product_SalesArea = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_ProdSR", // optional
    description: "Schema for WB_ProdSR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRODSR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PROD_ID: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        SALESORG: {
            type: "string",
            length: 50
        },
        DIVISION: {
            type: "string",
            length: 50
        },
        DISTRIBCHANNEL: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        STATUS_CODE: {
            type: "string",
            default: "",
            length: 50
        },
        WB_PROD_ID_PRC_REF: {
            type: "number"
        },
        WB_PRDGRP_ID_PRCGRP: {
            type: "number"
        },
        WB_PRDGRP_ID_SA: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        EXT_DELETION_IND: {
            type: "string",
            default: "",
            length: 1
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Finished_Product_SalesArea_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
            createIndex: true
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea",
            createIndex: true
        }
    }
}

export const WB_Product_Attribute = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdAttr", // optional
    description: "Schema for WB_PrdAttr records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDATTR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PROD_ID: {
            type: "number",
            default: 0
        },
        WB_PRDGRP_ID: {
            type: "number",
            default: 0
        },
        WB_ATTRIBUTEM_ID: {
            type: "number",
            default: 0
        },
        WB_SALESAREA_ID: {
            type: "number",
            default: 0
        },
        ENTITY_ID_UI: {
            type: "string",
            default: "",
            length: 50
        },
        ENTITY_KEYSET: {
            type: "string",
            default: "",
            length: 20
        },
        VALUE_WB_ID: {
            type: "number",
            default: 0
        },

        VALUE_STRING: {
            type: "string",
            default: "",
            length: 256
        },
        VALUE_NUMBER: {
            type: "number",
            default: 0
        },
        SOURCE_ID: {
            type: "string",
            default: "",
            length: 50
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Attribute_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
            createIndex: true
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
            createIndex: true
        },
        [PASchema.esWB_AttributeType]: {
            foreignKey: "WB_ATTRIBUTEM_ID",
            foreignKeyImmutable: true,
            localField: "AttributeType"
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        }
    }
}

export const WB_Finished_Product_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_ProdR", // optional
    description: "Schema for WB_ProdR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRODR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDH_ID: {
            type: "number"
        },
        WB_PROD_ID: {
            type: "number"
        },
        WB_PRDGRP_ID_PRNT: {
            type: "number"
        },
        EQV_UNIT_RATE: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        SOURCE_ROW_ID: {
            type: "string",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Finished_Product_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Hierarchy]: {
            foreignKey: "WB_PRDH_ID",
            foreignKeyImmutable: true,
            localField: "Hierarchy"
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
            createIndex: true
        },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID_PRNT",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
            createIndex: true
        }
    }
}

export const WB_Product_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Product_Type", // optional
    description: "Schema for WB_PrdM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDM_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0
        },
        PRDM_ID: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            default: "",
            length: 50
        },
        WB_ENTITY_ID: {
            type: "number",
            default: 0
        },
        KEY_SET_TYPE: {
            type: "string",
            length: 50
        },
        PRDM_NAME: {
            type: "string",
            length: 256
        },
        PRDM_TYPE: {
            type: "string",
            length: 50
        },
        CONSUMER_UPC_SHOW_IND: {
            type: "string",
            length: 1
        },
        CONSUMER_UPC_SEARCHABLE_IND: {
            type: "string",
            length: 1
        },
        SALESAREA_SHOW_IND: {
            type: "string",
            length: 1
        },
        SALESAREA_SEARCHABLE_IND: {
            type: "string",
            length: 1
        },
        STATUS_SHOW_IND: {
            type: "string",
            length: 1
        },
        STATUS_SEARCHABLE_IND: {
            type: "string",
            length: 1
        },
        BOM_SHOW_IND: {
            type: "string",
            length: 1
        },
        BOM_SEARCHABLE_IND: {
            type: "string",
            length: 1
        },
        UOM_SHOW_IND: {
            type: "string",
            length: 1
        },
        UOM_SEARCHABLE_IND: {
            type: "string",
            length: 1
        },
        SIZES_SHOW_IND: {
            type: "string",
            length: 1
        },
        SIZES_SEARCHABLE_IND: {
            type: "string",
            length: 1
        },
        HEADER_SHOW_FIELDS: {
            type: "string",
            length: 1333
        },
        HEADER_SEARCH_FIELDS: {
            type: "string",
            length: 1333
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Type_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        },
        [PASchema.esWB_Entity]: { foreignKey: "WB_ENTITY_ID", foreignKeyImmutable: true, localField: "Entity" }
    }
}

export const WB_Finished_Product_Tag_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Prod_TagR", // optional
    description: "Schema for WB_Prod_TagR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PROD_TAGR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PROD_ID: {
            type: "number"
        },
        WB_TAG_ID: {
            type: "number"
        },
        TAG_METHOD: {
            type: "string",
            length: 256
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Finished_Product_Tag_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Tag]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "ProdTag" },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product"
        }
    }
}

export const WB_Finished_Product_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_ProdT", // optional
    description: "Schema for WB_ProdT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRODT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PROD_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },
        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Finished_Product_Text_JSData_RELs = {}
// Product Group BO
export const WB_Product_Group = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdGrp", // optional
    description: "Schema for WB_PrdGrp records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDGRP_ID: {
            type: "number",
            id: true,
            required: true
        },
        PRODUCT_GROUP_ID: {
            type: "string",
            length: 50
        },
        PRODUCT_GROUP_SET_ID: {
            type: "string",
            length: 50
        },
        WB_MDSET_ID: {
            type: "number"
        },
        PRODUCT_GROUP_NAME: {
            type: "string",
            length: 256
        },
        WB_PRDM_ID: {
            type: "number"
        },
        LEVEL_ID: {
            type: "string",
            length: 50
        },
        STATUS_CODE: {
            type: "string",
            length: 50
        },
        TYPE_ID: {
            type: "string",
            length: 50
        },
        SUBTYPE_ID: {
            type: "string",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        PLANNED_IND: {
            type: "string",
            length: 1
        },
        BASE_UOM: {
            type: "string",
            length: 20
        },
        ORDER_UOM: {
            type: "string",
            length: 20
        },
        CASE_PACK_SIZE: {
            type: "number"
        },
        STAT_CS_FACTOR: {
            type: "number"
        },
        WEIGHT_FACTOR: {
            type: "number"
        },
        TREE_PATH: {
            type: "string",
            length: 256
        },
        CNSPRDDIM_IND: {
            type: "string",
            length: 1
        },
        CNSPRDDIM_ID_FIELDNAME: {
            type: "string",
            length: 256
        },
        CNSPRDDIM_NAME_FIELDNAME: {
            type: "string",
            length: 256
        },
        CNSPRDDIM_PRDGENPOLICY: {
            type: "string",
            length: 50
        },
        CNSPRDDIM_PRDEQVPOLICY: {
            type: "string",
            length: 50
        },
        CNSPRDDIM_WB_PRDH_ID: {
            type: "number"
        },
        CNSPRDDIM_SIZEATTRIBS: {
            type: "string",
            length: 50
        },
        CNSPRDDIM_EQVSTDSIZE: {
            type: "number"
        },
        HIER_NODE_IND: {
            type: "string",
            default: "",
            length: 1
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Group_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Type]: {
            foreignKey: "WB_PRDM_ID",
            foreignKeyImmutable: true,
            localField: "ProductType"
        },
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        }
    },
    hasMany: {
        [PASchema.esWB_Product_Group_SalesArea]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "SalesAreas"
        },
        [PASchema.esWB_Product_Group_Relationship]: [
            { foreignKey: "WB_PRDGRP_ID_PRNT", foreignKeyImmutable: true, localField: "Children" },
            { foreignKey: "WB_PRDGRP_ID", foreignKeyImmutable: true, localField: "Parents" }
        ],
        [PASchema.esWB_Product_Group_Attribute]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductAttributes"
        },
        [PASchema.esWB_Product_Group_LogicalKey]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "NodeLogicalKeys"
        },

        [PASchema.esWB_Finished_Product_Relationship]: {
            foreignKey: "WB_PRDGRP_ID_PRNT",
            foreignKeyImmutable: true,
            localField: "ChildProduct"
        },
        [PASchema.esWB_Product_Group_External_Relationship]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "Externals"
        },
        [PASchema.esWB_Product_Group_Tag_Relationship]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "PrdGrpTags"
        },
        [PASchema.esWB_Product_Group_UOM]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroupUOMs"
        },
        [PASchema.esWB_Product_Attribute]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroupAttributes"
        }
    }
}

export const WB_Product_Group_SalesArea = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdGrpSR", // optional
    description: "Schema for WB_PrdGrpSR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDGRPSR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDGRP_ID: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        SALESORG: {
            type: "string",
            length: 50
        },
        DIVISION: {
            type: "string",
            length: 50
        },
        DISTRIBCHANNEL: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Group_SalesArea_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup"
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        }
    }
}

export const WB_Product_Group_LogicalKey = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdGrpLKR", // optional
    description: "Schema for WB_PrdGrpLKR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDGRPLKR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDGRP_ID: {
            type: "number",
            default: 0
        },
        KEY_ID: {
            type: "string",
            default: "",
            length: 50
        },
        DATATYPE: {
            type: "string",
            default: "",
            length: 50
        },
        VALUE_WB_ENTITY_ID: {
            type: "number",
            default: 0
        },
        VALUE_WB_ID: {
            type: "number",
            default: 0
        },
        VALUE_WB_ATTRIBUTEM_ID: {
            type: "number",
            default: 0
        },
        VALUE_STRING: {
            type: "string",
            default: "",
            length: 256
        },
        VALUE_NUMBER: {
            type: "number",
            default: 0
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Group_LogicalKey_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup"
        }
    }
}

export const WB_Product_Group_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdGrpR", // optional
    description: "Schema for WB_PrdGrpR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDGRPR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDH_ID: {
            type: "number"
        },
        WB_PRDGRP_ID: {
            type: "number"
        },
        WB_PRDGRP_ID_PRNT: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        SOURCE_ROW_ID: {
            type: "string",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Group_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Hierarchy]: {
            foreignKey: "WB_PRDH_ID",
            foreignKeyImmutable: true,
            localField: "Hierarchy"
        },

        [PASchema.esWB_Product_Group]: [
            {
                foreignKey: "WB_PRDGRP_ID_PRNT",
                foreignKeyImmutable: true,
                localField: "Parent",
                createIndex: true
            },
            { foreignKey: "WB_PRDGRP_ID", foreignKeyImmutable: true, localField: "Child", createIndex: true }
        ]
    }
}

export const WB_Product_Group_External_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", //optional
    title: "WB_PrdGrp_ExtR", // optional
    description: "Schema for WB_PrdGrp_ExtR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDGRPEXTR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDGRP_ID: {
            type: "number"
        },
        GROUP_SET_ID: {
            type: "string",
            length: 50
        },
        REL_TYPE_ID: {
            type: "string",
            length: 50
        },
        WB_PRDATTRGRP_ID: {
            type: "number"
        },
        ATTRIBUTE_ID: {
            type: "string",
            length: 50
        },
        ATTRIBUTE_VALUE: {
            type: "string",
            length: 256
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        EXCLUDE_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Group_External_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup"
        }
    }
}

export const WB_Product_Group_Tag_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdGrp_TagR", // optional
    description: "Schema for WB_PrdGrp_TagR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDGRP_TAGR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDGRP_ID: {
            type: "number"
        },
        WB_TAG_ID: {
            type: "number"
        },
        TAG_METHOD: {
            type: "string",
            length: 256
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Product_Group_Tag_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Tag]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "PrdGrpTag" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup"
        }
    }
}

export const WB_Product_Group_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdGrpT", // optional
    description: "Schema for WB_PrdGrpT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDGRPT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDGRP_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },

        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Group_Text_JSData_RELs = {}

export const WB_Product_BOM = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", //optional
    title: "WB_PROD_BOM", // optional
    description: "Schema for WB_PROD_BOM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PROD_BOM_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PROD_ID: {
            type: "number"
        },
        WB_PROD_ID_COMP: {
            type: "number"
        },
        COMP_FINISHED_PRODUCT_IND: {
            type: "string",
            length: 1
        },
        COMPONENT_QTY: {
            type: "number"
        },
        COMPONENT_UOM: {
            type: "string",
            length: 20
        },
        COMPONENT_QTY_BUOM: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        SOURCE_KEY: {
            type: "string",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        }
    }
})
export const WB_Product_BOM_JSData_RELS = {
    belongsTo: {
        [PASchema.esWB_Finished_Product]: [
            { foreignKey: "WB_PROD_ID", foreignKeyImmutable: true, localField: "Product" },
            { foreignKey: "WB_PROD_ID_COMP", foreignKeyImmutable: true, localField: "ComponentProduct" }
        ]
    }
}

export const WB_Product_BOM_Component = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", //optional
    title: "WB_PRDBOM_COMP", // optional
    description: "Schema for WB_PRDBOM_COMP records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PROD_BOM_COMP_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PROD_ID: {
            type: "number"
        },
        WB_PROD_ID_COMP: {
            type: "number"
        },
        COMPONENT_QTY: {
            type: "number"
        },
        COMPONENT_UOM: {
            type: "string",
            length: 20
        },
        COMPONENT_QTY_BUOM: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        }
    }
})
export const WB_Product_BOM_Component_JSData_RELS = {
    belongsTo: {
        [PASchema.esWB_Finished_Product]: [
            { foreignKey: "WB_PROD_ID", foreignKeyImmutable: true, localField: "Product" },
            { foreignKey: "WB_PROD_ID_COMP", foreignKeyImmutable: true, localField: "ComponentProduct" }
        ]
    }
}

export const WB_Product_UOM = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", //optional
    title: "WB_PROD_UOM", // optional
    description: "Schema for WB_PROD_UOM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PROD_UOM_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PROD_ID: {
            type: "number"
        },
        PRODUCT_UOM: {
            type: "string",
            length: 20
        },
        CONVERSION_FACTOR: {
            type: "number"
        },
        UOM_UPC: {
            type: "string",
            length: 50
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        SOURCE_KEY: {
            type: "string",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        }
    }
})
export const WB_Product_UOM_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "FinishedProduct"
        }
    }
}

export const WB_Product_Group_UOM = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", //optional
    title: "WB_PRDGRPUM", // optional
    description: "Schema for WB_PRDGRPUM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDGRP_UOM_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDGRP_ID: {
            type: "number"
        },
        PRODUCT_UOM: {
            type: "string",
            length: 20
        },
        CONVERSION_FACTOR: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        SOURCE_KEY: {
            type: "string",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        }
    }
})
export const WB_Product_Group_UOM_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup"
        }
    }
}

export const WB_UOM = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UOM", // optional
    description: "Schema for WB_UOM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UOM_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0
        },
        UOM_ID: {
            type: "string",
            length: 20
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            default: "",
            length: 50
        },
        UOM_NAME: {
            type: "string",
            length: 256
        },
        ISO_CODE: {
            type: "string",
            length: 20
        },
        SORT_ORDER: {
            type: "number"
        },
        PRODUCT_UOM: {
            type: "string",
            length: 20
        },
        RPT_ENABLED_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_UOM_JSData_RELs = {
    hasMany: {}
}

export const WB_UOM_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UOMT", // optional
    description: "Schema for WB_UOMT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UOMT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_UOM_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },

        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_UOM_Text_JSData_RELs = {}

export const WB_Product_Group_Attribute = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdGrpAR", // optional
    description: "Schema for WB_PrdGrpAR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDGRPAR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDGRP_ID: {
            type: "number"
        },
        ATTRIBUTE_ID: {
            type: "string",
            length: 50
        },
        ATTRIBUTE_VALUE: {
            type: "string",
            length: 256
        },
        EXCLUDE_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Product_Group_Attribute_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup"
        }
    }
}

// Product Hierarchy
export const WB_Product_Hierarchy = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdH", // optional
    description: "Schema for WB_PrdH records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDH_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRD_HIER_ID: {
            type: "string",
            length: 50
        },
        WB_PRD_HIER_NAME: {
            type: "string",
            length: 256
        },
        PRODUCT_HIERARCHY_TYPE: {
            type: "string",
            length: 50
        },
        HIERARCHY_USAGE: {
            type: "string",
            length: 50
        },
        WB_MDSET_ID: {
            type: "number"
        },

        PRODUCT_GROUP_SET_ID: {
            type: "string",
            length: 50
        },
        TPM_PRD_HIER_ROW_ID: {
            type: "string",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        HIERARCHY_ID: {
            type: "string",
            length: 50
        },
        CATEGORY_LEVEL: {
            type: "string",
            length: 50
        },
        BRAND_LEVEL: {
            type: "string",
            length: 50
        },
        PROMOTEDGROUP_LEVEL: {
            type: "string",
            length: 50
        },
        LEAF_TYPE: {
            type: "string",
            length: 50
        },
        WB_PRDH_ID_CPPG: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },

        DELETED_DT: {
            type: "string",
            default: "00000000",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            default: "",
            length: 1
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Product_Hierarchy_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        }
    },
    hasMany: {
        [PASchema.esWB_Product_Hierarchy_Level]: {
            foreignKey: "WB_PRDH_ID",
            foreignKeyImmutable: true,
            localField: "ProductHierarchyLevel"
        },
        [PASchema.esWB_Product_Hierarchy_SalesArea]: {
            foreignKey: "WB_PRDH_ID",
            foreignKeyImmutable: true,
            localField: "SalesAreas"
        }
    }
}

export const WB_Product_Hierarchy_SalesArea = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdHSR", // optional
    description: "Schema for WB_PrdHSR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDHSR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDH_ID: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        SALESORG: {
            type: "string",
            length: 50
        },
        DIVISION: {
            type: "string",
            length: 50
        },
        DISTRIBCHANNEL: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },

        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Hierarchy_SalesArea_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Hierarchy]: {
            foreignKey: "WB_PRDH_ID",
            foreignKeyImmutable: true,
            localField: "ProductHierarchy"
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        }
    }
}

export const WB_Product_Hierarchy_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdHT", // optional
    description: "Schema for WB_PrdHT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDHT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDH_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },

        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Hierarchy_Text_JSData_RELs = {}

// Product Hierarchy Level
export const WB_Product_Hierarchy_Level = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdH_Level", // optional
    description: "Schema for WB_PrdH_Level records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDH_LEVEL_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDH_ID: {
            type: "number"
        },
        LEVEL_DEPTH: {
            type: "number"
        },
        LEVEL_ID: {
            type: "string",
            length: 50
        },
        LEVEL_NAME: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Product_Hierarchy_Level_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Hierarchy]: {
            foreignKey: "WB_PRDH_ID",
            foreignKeyImmutable: true,
            localField: "ProductHierarchy"
        }
    }
}

// Consumer Product
export const WB_Consumer_Product_Alignment = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UpcPrdR", // optional
    description: "Schema for WB_UpcPrdR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UPCPRDR_ID: {
            type: "number",
            id: true,
            required: true
        },
        CONSUMER_UPC: {
            type: "string",
            length: 50
        },
        WB_PROD_ID: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Consumer_Product_Alignment_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "FinishedProduct"
        }
    }
}

export const WB_Consumer_Product_Customer_Alignment = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_UpcPrdPR", // optional
    description: "Schema for WB_UpcPrdPR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_UPCPRDR_ID: {
            type: "number",
            id: true,
            required: true
        },
        CONSUMER_UPC: {
            type: "string",
            length: 50
        },
        WB_PROD_ID: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Consumer_Product_Customer_Alignment_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "FinishedProduct"
        },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" }
    }
}

// Period BO
export const WB_Period = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Period", // optional
    description: "Schema for WB_Period records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PERIOD_ID: {
            type: "number",
            id: true,
            required: true
        },
        PERIOD_ID: {
            type: "string",
            length: 50
        },
        PERIOD_SET_ID: {
            type: "string",
            default: "",
            length: 50
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0
        },
        PERIOD_NAME: {
            type: "string",
            length: 256
        },
        PERIOD_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        PERIOD_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        EXTENDED_PERIOD_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EXTENDED_PERIOD_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        TREE_PATH: {
            type: "string",
            length: 256
        },
        PERIOD_ROW_ID: {
            type: "string",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        WB_PERIODM_ID: {
            type: "number"
        },
        FISCAL_YEAR_ID: {
            type: "number"
        },
        PERIOD_OF_FISCAL_YEAR: {
            type: "number"
        },
        PERIOD_NUMBER: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Period_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Period_Type]: {
            foreignKey: "WB_PERIODM_ID",
            foreignKeyImmutable: true,
            localField: "PeriodType"
        },
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        },
        [PASchema.esWB_Source]: { foreignKey: "WB_SOURCE_ID", foreignKeyImmutable: true, localField: "Source" }
    },
    hasMany: {
        [PASchema.esWB_Period_Relationship]: [
            {
                foreignKey: "WB_PERIOD_ID_PRNT",
                foreignKeyImmutable: true,
                localField: "Children"
            },
            { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Parents" }
        ],
        [PASchema.esWB_Period_Company_Relationship]: {
            foreignKey: "WB_PERIOD_ID",
            foreignKeyImmutable: true,
            localField: "PeriodCompanyRelationship"
        },
        [PASchema.esWB_Period_Attribute]: {
            foreignKey: "WB_PERIOD_ID",
            foreignKeyImmutable: true,
            localField: "PeriodAttributes"
        }
    }
}

export const WB_Period_Attribute = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PeriodAttr", // optional
    description: "Schema for WB_PeriodAttr records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PERIODATTR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PERIOD_ID: {
            type: "number",
            default: 0
        },
        WB_ATTRIBUTEM_ID: {
            type: "number",
            default: 0
        },
        WB_SALESAREA_ID: {
            type: "number",
            default: 0
        },
        ENTITY_ID_UI: {
            type: "string",
            default: "",
            length: 50
        },
        ENTITY_KEYSET: {
            type: "string",
            default: "",
            length: 20
        },
        VALUE_WB_ID: {
            type: "number",
            default: 0
        },

        VALUE_STRING: {
            type: "string",
            default: "",
            length: 256
        },
        VALUE_NUMBER: {
            type: "number",
            default: 0
        },
        SOURCE_ID: {
            type: "string",
            default: "",
            length: 50
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Period_Attribute_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
        [PASchema.esWB_AttributeType]: {
            foreignKey: "WB_ATTRIBUTEM_ID",
            foreignKeyImmutable: true,
            localField: "AttributeType"
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        }
    }
}

export const WB_Period_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Period_Relationship", // optional
    description: "Schema for WB_PeriodR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PERIODR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PERIOD_ID: {
            type: "number"
        },
        WB_PERIOD_ID_PRNT: {
            type: "number"
        },
        WB_PERIODH_ID: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        SOURCE_ROW_ID: {
            type: "string",
            length: 50
        }
    }
})
export const WB_Period_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Period]: [
            {
                foreignKey: "WB_PERIOD_ID_PRNT",
                foreignKeyImmutable: true,
                localField: "Parent",
                createIndex: true
            },
            { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Child", createIndex: true }
        ]
    }
}

export const WB_Period_Tag_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Period_Tag_Relationship", // optional
    description: "Schema for WB_Period_TagR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PERIOD_TAGR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PERIOD_ID: {
            type: "number"
        },
        WB_TAG_ID: {
            type: "number"
        },
        TAG_METHOD: {
            type: "string",
            length: 50
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Period_Tag_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
        [PASchema.esWB_Tag]: { foreignKey: "WB_TAG_ID", foreignKeyImmutable: true, localField: "Tag" }
    }
}

// Period Type BO
export const WB_Period_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PeriodM", // optional
    description: "Schema for WB_PeriodM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PERIODM_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0
        },
        PERIOD_TYPE_ID: {
            type: "string",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            default: "",
            length: 50
        },
        PERIOD_TYPE_NAME: {
            type: "string",
            length: 256
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        TECHNICAL_WEEK_IND: {
            type: "string",
            length: 1
        },
        YEAR_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Period_Type_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        }
    }
}

//Periodh BO

export const WB_Period_Hierarchy = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Periodh", // optional
    description: "Schema for WB_Periodh records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PERIODH_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0
        },
        WB_PERIOD_HIER_ID: {
            type: "string",
            length: 50
        },
        WB_PERIOD_HIER_NAME: {
            type: "string",
            length: 256
        },
        PERIOD_HIERARCHY_TYPE: {
            type: "string",
            length: 50
        },
        TPM_PERIOD_HIER_ROW_ID: {
            type: "string",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            default: "",
            length: 1
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Period_Hierarchy_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        }
    },
    hasMany: {
        [PASchema.esWB_Period_Hierarchy_Level]: {
            foreignKey: "WB_PERIODH_ID",
            foreignKeyImmutable: true,
            localField: "PeriodHierarchyLevel"
        },
        [PASchema.esWB_Period_Hierarchy_Company_Relationship]: {
            foreignKey: "WB_PERIODH_ID",
            foreignKeyImmutable: true,
            localField: "PeriodHierarchyCompanyRelationship"
        }
    }
}

export const WB_Period_Hierarchy_Company_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PeriodHCR", // optional
    description: "Schema for WB_PeriodHCR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PERIODHCR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PERIODH_ID: {
            type: "number",
            default: 0
        },
        WB_COMPANY_ID: {
            type: "number",
            default: 0
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Period_Hierarchy_Company_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Period_Hierarchy]: {
            foreignKey: "WB_PERIODH_ID",
            foreignKeyImmutable: true,
            localField: "PeriodHierarchy"
        },
        [PASchema.esWB_Company]: { foreignKey: "WB_COMPANY_ID", foreignKeyImmutable: true, localField: "Company" }
    }
}

export const WB_Period_Company_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PeriodCR", // optional
    description: "Schema for WB_PeriodCR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PERIODCR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PERIOD_ID: {
            type: "number",
            default: 0
        },
        WB_COMPANY_ID: {
            type: "number",
            default: 0
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Period_Company_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
        [PASchema.esWB_Company]: { foreignKey: "WB_COMPANY_ID", foreignKeyImmutable: true, localField: "Company" }
    }
}

// Period Hierarchy Level
export const WB_Period_Hierarchy_Level = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PeriodH_Level", // optional
    description: "Schema for WB_PeriodH_Level records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PERIODH_LEVEL_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PERIODH_ID: {
            type: "number"
        },
        LEVEL_DEPTH: {
            type: "number"
        },
        WB_PERIODM_ID: {
            type: "number"
        },
        LEVEL_ID: {
            type: "string",
            length: 50
        },
        LEVEL_NAME: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        INTEGRATION_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Period_Hierarchy_Level_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Period_Hierarchy]: {
            foreignKey: "WB_PERIODH_ID",
            foreignKeyImmutable: true,
            localField: "PeriodHierarchy"
        },
        [PASchema.esWB_Period_Type]: { foreignKey: "WB_PERIODM_ID", foreignKeyImmutable: true, localField: "Type" }
    }
}

// Consumption Product Group
export const WB_Consumption_Product_Group = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CnsPG", // optional
    description: "Schema for WB_CnsPG records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CNSPG_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CUST_ID_PLANNING: {
            type: "number"
        },
        WB_CUST_ID_SOURCE: {
            type: "number"
        },
        WB_PRDGRP_ID: {
            type: "number"
        },
        START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        END_DT: {
            type: "string",
            default: "99991231",
            length: 8
        },
        WB_CNSPG_ID_PREV: {
            type: "number"
        },
        WB_CNSPG_ID_NEXT: {
            type: "number"
        },
        QTY_UOM: {
            type: "string",
            length: 20
        },
        QTY_UOM_TO_UNITS: {
            type: "number"
        },
        WT_UOM_PER_UNIT: {
            type: "number"
        },
        STAT_UOM_PER_UNIT: {
            type: "number"
        },
        RTLSLS_UOM_PER_UNIT: {
            type: "number"
        },
        RTLSLS_UOM_PER_BASE_UNIT: {
            type: "number"
        },
        RTLSLS_UOM_PER_INCR_UNIT: {
            type: "number"
        },
        BS_BASE_QTY_OVRD: {
            type: "number"
        },
        BS_BASE_QTY_ADJ: {
            type: "number"
        },
        BS_PROMOBASE_QTY_OVRD: {
            type: "number"
        },
        BS_PROMOBASE_QTY_ADJ: {
            type: "number"
        },
        IS_INCR_SHIFT_QTY_PREV: {
            type: "number"
        },
        IS_INCR_SHIFT_QTY_NEXT: {
            type: "number"
        },
        SYND_BASE_PRICE: {
            type: "number"
        },
        SYND_PROMOTED_PRICE: {
            type: "number"
        },
        SYND_COVERAGE_FACTOR: {
            type: "number"
        },
        SYND_CNS_BASE_UNITS: {
            type: "number"
        },
        SYND_CNS_BASE_WT: {
            type: "number"
        },
        SYND_CNS_BASE_STAT: {
            type: "number"
        },
        SYND_CNS_BASE_RTLSLS: {
            type: "number"
        },
        SYND_CNS_PROMOBASE_UNITS: {
            type: "number"
        },
        SYND_CNS_PROMOBASE_WT: {
            type: "number"
        },
        SYND_CNS_PROMOBASE_STAT: {
            type: "number"
        },
        SYND_CNS_PROMOBASE_RTLSLS: {
            type: "number"
        },
        SYND_CNS_INCR_UNITS: {
            type: "number"
        },
        SYND_CNS_INCR_STAT: {
            type: "number"
        },
        SYND_CNS_INCR_WT: {
            type: "number"
        },
        SYND_CNS_INCR_RTLSLS: {
            type: "number"
        },
        SYND_CNS_TOTAL_UNITS: {
            type: "number"
        },
        SYND_CNS_TOTAL_STAT: {
            type: "number"
        },
        SYND_CNS_TOTAL_WT: {
            type: "number"
        },
        SYND_CNS_TOTAL_RTLSLS: {
            type: "number"
        },
        BS_CNS_BASE_UNITS: {
            type: "number"
        },
        BS_CNS_BASE_WT: {
            type: "number"
        },
        BS_CNS_BASE_STAT: {
            type: "number"
        },
        BS_CNS_BASE_RTLSLS: {
            type: "number"
        },
        BS_CNS_PROMOBASE_UNITS: {
            type: "number"
        },
        BS_CNS_PROMOBASE_WT: {
            type: "number"
        },
        BS_CNS_PROMOBASE_STAT: {
            type: "number"
        },
        BS_CNS_PROMOBASE_RTLSLS: {
            type: "number"
        },
        BS_CNS_INCR_UNITS: {
            type: "number"
        },
        BS_CNS_INCR_STAT: {
            type: "number"
        },
        BS_CNS_INCR_WT: {
            type: "number"
        },
        BS_CNS_INCR_RTLSLS: {
            type: "number"
        },
        IS_CNS_INCR_UNITS_OUT: {
            type: "number"
        },
        IS_CNS_INCR_STAT_OUT: {
            type: "number"
        },
        IS_CNS_INCR_WT_OUT: {
            type: "number"
        },
        IS_CNS_INCR_RTLSLS_OUT: {
            type: "number"
        },
        IS_CNS_INCR_UNITS_PREV: {
            type: "number"
        },
        IS_CNS_INCR_STAT_PREV: {
            type: "number"
        },
        IS_CNS_INCR_WT_PREV: {
            type: "number"
        },
        IS_CNS_INCR_RTLSLS_PREV: {
            type: "number"
        },
        IS_CNS_INCR_UNITS_NEXT: {
            type: "number"
        },
        IS_CNS_INCR_STAT_NEXT: {
            type: "number"
        },
        IS_CNS_INCR_WT_NEXT: {
            type: "number"
        },
        IS_CNS_INCR_RTLSLS_NEXT: {
            type: "number"
        }
    }
})
export const WB_Consumption_Product_Group_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Customer]: [
            {
                foreignKey: "WB_CUST_ID_PLANNING",
                foreignKeyImmutable: true,
                localField: "PlanningCustomer"
            },
            { foreignKey: "WB_CUST_ID_SOURCE", foreignKeyImmutable: true, localField: "SourceCustomer" }
        ],
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup"
        },
        [PASchema.esWB_Consumption_Product_Group]: [
            {
                foreignKey: "WB_CNSPG_ID_PREV",
                foreignKeyImmutable: true,
                localField: "Previous"
            },
            { foreignKey: "WB_CNSPG_ID_NEXT", foreignKeyImmutable: true, localField: "Next" }
        ]
    }
    /* Remove this until we can disable the load in Record Resolver
    hasMany: {
        [PASchema.esWB_Consumption_Product]:       { foreignKey: 'WB_CNSPG_ID',      foreignKeyImmutable: true, localField: 'ConsProducts' }
    }*/
}

export const WB_Consumption_Product = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CnsPrd", // optional
    description: "Schema for WB_CnsPrd records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CNSPRD_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CNSPG_ID: {
            type: "number"
        },
        CONSUMER_PRODUCT_ID: {
            type: "string",
            length: 50
        },
        WB_PROD_ID: {
            type: "number"
        },
        ALLOC_BASIS_PCNT: {
            type: "number"
        },
        ALLOC_BASIS_QTY: {
            type: "number"
        },
        PROMO_ALLOC_BASIS_PCNT: {
            type: "number"
        },
        PROMO_ALLOC_BASIS_QTY: {
            type: "number"
        }
    }
})
export const WB_Consumption_Product_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product"
        }
    }
}

// Currency
export const WB_Currency = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Currency", // optional
    description: "Schema for WB_Currency records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CURRENCY_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0
        },
        CURRENCY_ID: {
            type: "string",
            default: "",
            length: 50
        },
        ENTERPRISE_SET_ID: {
            type: "string",
            default: "",
            length: 50
        },
        CURRENCY_NAME: {
            type: "string",
            default: "",
            length: 256
        },
        ISO_CURRENCY: {
            type: "string",
            default: "",
            length: 20
        },
        PRIMARY_IND: {
            type: "string",
            default: "",
            length: 1
        },
        CURRENCY_SYMBOL: {
            type: "string",
            default: "",
            length: 2
        },
        CURRENCY_SYMBOL_POSITION: {
            type: "string",
            default: "",
            length: 20
        },
        DECIMAL_SYMBOL: {
            type: "string",
            default: "",
            length: 2
        },
        DECIMAL_DIGITS: {
            type: "number",
            default: 0
        },
        GROUPING_SYMBOL: {
            type: "string",
            default: "",
            length: 2
        },
        NEGATIVE_FORMAT: {
            type: "string",
            default: "",
            length: 50
        },
        MANUAL_IND: {
            type: "string",
            default: "",
            length: 1
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Currency_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MasterDataSet"
        }
    },
    hasMany: {
        [PASchema.esWB_CurrencyT]: {
            foreignKey: "WB_CURRENCY_ID",
            foreignKeyImmutable: true,
            localField: "CurrencyText"
        }
    }
}

export const WB_CurrencyT = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_CurrencyT", // optional
    description: "Schema for WB_CurrencyT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CURRENCYT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_CURRENCY_ID: {
            type: "number",
            id: true
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },
        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_CurrencyT_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Currency]: { foreignKey: "WB_CURRENCY_ID", foreignKeyImmutable: true, localField: "Currency" }
    }
}

// Product Attribute Group
export const WB_Product_Attribute_Group = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdAttrGrp", // optional
    description: "Schema for WB_PrdAttrGrp records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDATTRGRP_ID: {
            type: "number",
            id: true,
            required: true
        },
        ATTRIB_GROUP_ID: {
            type: "string",
            length: 50
        },
        ATTRIB_GROUP_NAME: {
            type: "string",
            length: 256
        },
        TREEPATH: {
            type: "string",
            length: 256
        },
        CNSPRDDIM_IND: {
            type: "string",
            length: 1
        },
        CNSPRDDIM_ID_FIELDNAME: {
            type: "string",
            length: 256
        },
        CNSPRDDIM_NAME_FIELDNAME: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Attribute_Group_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Product_Attribute_Group_Relationship]: {
            foreignKey: "WB_PRDATTRGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductAttributes"
        }
    }
}

export const WB_Product_Attribute_Group_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdAttrGrpR", // optional
    description: "Schema for WB_PrdAttrGrpR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDATTRGRPR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDATTRGRP_ID: {
            type: "number"
        },
        ATTRIBUTE_ID: {
            type: "string",
            length: 50
        },
        ATTRIBUTE_VALUE: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Attribute_Group_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Attribute_Group]: {
            foreignKey: "WB_PRDATTRGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductAttributeGroup"
        }
    }
}

//Product Attribute Map
export const WB_Product_Attribute_Map = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdAttrMap", // optional
    description: "Schema for WB_PrdAttrMap records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDATTRMAP_ID: {
            type: "number",
            id: true,
            required: true
        },
        ATTRIB_MAP_ID: {
            type: "string",
            length: 50
        },
        ATTRIB_MAP_NAME: {
            type: "string",
            length: 256
        },
        ATTRIB_MAP_TYPE: {
            type: "string",
            length: 50
        },
        TREE_PATH: {
            type: "string",
            length: 256
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        ATTRIBUTE_ID: {
            type: "string",
            length: 50
        },
        TARGET_FIELDNAME: {
            type: "string",
            length: 50
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Attribute_Map_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Product_Attribute_Map_External_Relationship]: {
            foreignKey: "WB_PRDATTRMAP_ID",
            foreignKeyImmutable: true,
            localField: "ProdAttrMapExtRs"
        },
        [PASchema.esWB_Product_Attribute_Map_Value_Relationship]: {
            foreignKey: "WB_PRDATTRMAP_ID",
            foreignKeyImmutable: true,
            localField: "ProdAttrMapValRs"
        }
    }
}

export const WB_Product_Attribute_Map_External_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdAttrMap_ExtR", // optional
    description: "Schema for WB_PrdAttrMap_ExtR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDATTRMAPEXTR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDATTRMAP_ID: {
            type: "number"
        },
        SOURCE_ID: {
            type: "string",
            length: 50
        },
        ATTRIBUTE_ID: {
            type: "string",
            length: 50
        },
        TARGET_ATTRIBUTE_ID: {
            type: "string",
            length: 50
        },
        CNSPRDDIM_FIELDNAME: {
            type: "string",
            length: 256
        },
        ATTRMAP_POLICY: {
            type: "string",
            length: 50
        },
        ATTRIBUTE_DATATYPE: {
            type: "string",
            length: 50
        },
        ATTRIBUTE_FORMAT: {
            type: "string",
            length: 50
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Attribute_Map_External_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Attribute_Map]: {
            foreignKey: "WB_PRDATTRMAP_ID",
            foreignKeyImmutable: true,
            localField: "ProdAttrMap"
        }
    }
}

export const WB_Product_Attribute_Map_Value_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PrdAttrMap_ValueR", // optional
    description: "Schema for WB_PrdAttrMap_ValueR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PRDATTRMAPVALUER_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_PRDATTRMAP_ID: {
            type: "number"
        },
        ATTRIBUTE_VALUE: {
            type: "string",
            length: 256
        },
        TARGET_VALUE: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Product_Attribute_Map_Value_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Product_Attribute_Map]: {
            foreignKey: "WB_PRDATTRMAP_ID",
            foreignKeyImmutable: true,
            localField: "ProdAttrMap"
        }
    }
}

// Product
export const WB_External_Product_Relationship = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Prod", // optional
    description: "Schema for WB_Prod records", // optional
    type: "object",
    track: true,
    "properties": {
        "WB_EXTPRDR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "SOURCE_ID": {
            "type": "string",
            "length": 50
        },
        "EXTERNAL_PRODUCT_ID": {
            "type": "string",
            "length": 256
        },
        "WB_PROD_ID": {
            "type": "number",
            "required": true
        },
        "MANUAL_IND": {
            "type": "string",
            "length": 1
        },
        "CREATED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "MODIFIED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
})
export const WB_External_Product_Relationship_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product"
        }
    }
}


export const WB_Hierarchy = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Hierarchy", // optional
    description: "Schema for WB_Hierarchy records", // optional
    type: "object",
    track: true,
    properties: {
        WB_HIERARCHY_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: "number"
        },
        WB_SCHEDULE_ID: {
            type: "number"
        },
        ENTITY_DIMENSION: {
            type: "string",
            default: "",
            length: 50
        },
        HIERARCHY_ID: {
            type: "string",
            default: "",
            length: 50
        },
        SOURCE_ID: {
            type: "string",
            default: "",
            length: 50
        },
        HIERARCHY_NAME: {
            type: "string",
            default: "",
            length: 256
        },
        HIERARCHY_STATUS: {
            type: "string",
            default: "",
            length: 50
        },
        EFFECTIVE_DATE_POLICY: {
            type: "string",
            default: "",
            length: 50
        },
        STAGING_POLICY: {
            type: "string",
            default: "",
            length: 50
        },
        ENTERPRISE_NODES_IND: {
            type: "string",
            length: 1
        },
        TARGET_WB_ID: {
            type: "number"
        },
        HIERARCHY_WORKFLOW_MODE: {
            type: "string",
            default: "",
            length: 50
        },
        EXTERNAL_HIERARCHY_ID: {
            type: "string",
            default: "",
            length: 256
        },
        IK_WB_ATTRIBUTEM_ID: {
            type: "number"
        },
        IK_WB_SALESAREA_ID: {
            type: "number"
        },
        NODE_WB_SET_ID: {
            type: "number"
        },
        RELATIONSHIP_TIME_POLICY: {
            type: "string",
            default: "",
            length: 50
        },
        APPLICATION_AREAS: {
            type: "string",
            default: "",
            length: 500
        },
        EXPORT_TO_LANDING_ZONE: {
            type: "string",
            length: 1
        },
        EXTRACT_ATTRIBUTES_IND: {
            type: "string",
            length: 1
        },
        EXTRACT_ENTITIES_IND: {
            type: "string",
            length: 1
        },
        EXTRACT_ENTITIES_SETNAME_IND: {
            type: "string",
            length: 1
        },
        INCLUDE_INACTIVE_IND: {
            type: "string",
            length: 1
        },
        BATCH_MODE_IND: {
            type: "string",
            length: 1
        },
        SKIP_LEAF_ES_SCOPE_IND: {
            type: "string",
            length: 1
        },
        EXCLUDE_MANUAL_RELS_IND: {
            type: "string",
            length: 1
        },
        UNBALANCED_ERROR_POLICY: {
            type: "string",
            default: "",
            length: 50
        },
        RAGGED_ERROR_POLICY: {
            type: "string",
            default: "",
            length: 50
        },
        ENTITY_TYPING_POLICY: {
            type: "string",
            default: "",
            length: 50
        },
        WORKER_COUNT: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        HIERARCHY_EXPORT_ID_SEPARATOR: {
            type: "string",
            default: "",
            length: 10
        },
        HIERARCHY_EXPORT_ENTERPRISE_SEPARATOR: {
            type: "string",
            default: "",
            length: 10
        },
        ENTERPRISE_SEPARATOR_LOCATION: {
            type: "string",
            default: "",
            length: 10
        },
        GENERATE_FLAT_HIER_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Hierarchy_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Hierarchy_Level]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "HierarchyLevels"
        },
        [PASchema.esWB_Hierarchy_SalesArea]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "HierarchySalesAreas"
        },
        [PASchema.esWB_Hierarchy_Period]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "HierarchyPeriods"
        },
        [PASchema.esWB_Hierarchy_Entity_Generation]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "HierarchyEntities"
        },
        [PASchema.esWB_Hierarchy_Attribute_Generation]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "HierarchyAttributes"
        },

        [PASchema.esWB_Hierarchy_Intelligent_Key]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "HierarchyIntelligentKeys"
        },
        [PASchema.esWB_Hierarchy_MDScope]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "HierarchyMDScopes"
        }
    },
    belongsTo: {
        [PASchema.esWB_Schedule]: {
            foreignKey: "WB_SCHEDULE_ID",
            foreignKeyImmutable: true,
            localField: "HierarchySchedule"
        }
    }
}

export const WB_Hierarchy_Level = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_HierarchyLR", // optional
    description: "Schema for WB_HierarchyLR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_HIERARCHYLR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_HIERARCHY_ID: {
            type: "number"
        },
        LEVEL_DEPTH: {
            type: "number"
        },
        LEVEL_ID: {
            type: "string",
            default: "",
            length: 50
        },
        LEVEL_NAME: {
            type: "string",
            default: "",
            length: 256
        },
        WB_ENTITY_ID: {
            type: "number"
        },
        WB_ATTRIBUTEM_ID: {
            type: "number"
        },
        WB_ENTITY_ID_ENTERPRISE: {
            type: "number"
        },
        UNIQUE_IND: {
            type: "string",
            length: 1
        },
        PATH: {
            type: "string",
            length: 500
        },
        FLATTEN_IND: {
            type: "string",
            length: 1
        },
        MANUAL_IND: {
            type: "string"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Hierarchy_Level_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Hierarchy]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "Hierarchy"
        },
        [PASchema.esWB_Entity]: [
            {
                foreignKey: "WB_ENTITY_ID",
                foreignKeyImmutable: true,
                localField: "Entity"
            },
            {
                foreignKey: "WB_ENTITY_ID_ENTERPRISE",
                foreignKeyImmutable: true,
                localField: "EntityEnterprise"
            }
        ],
        [PASchema.esWB_AttributeType]: {
            foreignKey: "WB_ATTRIBUTEM_ID",
            foreignKeyImmutable: true,
            localField: "AttributeType"
        }
    }
}

export const WB_Hierarchy_Period = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_HierarchyMPR", // optional
    description: "Schema for WB_HierarchyMPR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_HIERARCHYMPR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_HIERARCHY_ID: {
            type: "number"
        },
        PERIOD_NAME: {
            type: "string",
            default: "",
            length: 256
        },
        PERIOD_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        PERIOD_END_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        INIT_IND: {
            type: "string",
            length: 1
        },
        ACTIVE_IND: {
            type: "string",
            length: 1
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Hierarchy_Period_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Hierarchy]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "Hierarchy"
        }
    }
}

export const WB_Hierarchy_SalesArea = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_HierarchySR", // optional
    description: "Schema for WB_HierarchySR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_HIERARCHYSR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_HIERARCHY_ID: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Hierarchy_SalesArea_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Hierarchy]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "Hierarchy"
        },
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        }
    }
}

export const WB_Hierarchy_Entity_Generation = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_HierarchyEGR", // optional
    description: "Schema for WB_HierarchyEGR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_HIERARCHYEGR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_HIERARCHY_ID: {
            type: "number"
        },
        WB_HIERARCHYLR_ID: {
            type: "number"
        },
        WB_ATTRIBUTEM_ID_LEVEL: {
            type: "number"
        },
        WB_ENTITY_ID: {
            type: "number"
        },
        WB_SET_ID: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})

export const WB_Hierarchy_Entity_Generation_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Hierarchy]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "Hierarchy"
        },
        [PASchema.esWB_Entity]: {
            foreignKey: "WB_ENTITY_ID",
            foreignKeyImmutable: true,
            localField: "Entity"
        },
        [PASchema.esWB_Hierarchy_Level]: {
            foreignKey: "WB_HIERARCHYLR_ID",
            foreignKeyImmutable: true,
            localField: "HierarchyLevel"
        }
    }
}

export const WB_Hierarchy_Attribute_Generation = new Schema({
    $schema: 'http://json-schema.org/draft-04/schema#', // optional
    title: 'WB_HierarchyAGR', // optional
    description: 'Schema for WB_HierarchyAGR records', // optional
    type: 'object',
    track: true,
    properties: {
        WB_HIERARCHYAGR_ID: {
            type: 'number',
            id: true,
            required: true
        },
        WB_HIERARCHY_ID: {
            type: 'number'
        },
        WB_HIERARCHYLR_ID: {
            type: 'number'
        },
        WB_ATTRIBUTEM_ID_LEVEL: {
            type: 'number'
        },
        WB_ENTITY_ID: {
            type: 'number'
        },
        WB_ATTRIBUTEM_ID: {
            type: 'number'
        },
        CREATED_DTTS: {
            type: 'number'
        },
        MODIFIED_DTTS: {
            type: 'number'
        },
        DELETED_IND: {
            type: 'string',
            length: 1
        },
        DELETED_DT: {
            type: 'string',
            default: '18000101',
            length: 8
        }
    }
})

export const WB_Hierarchy_Attribute_Generation_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Hierarchy]: {
            foreignKey: 'WB_HIERARCHY_ID',
            foreignKeyImmutable: true,
            localField: 'Hierarchy'
        },
        [PASchema.esWB_Entity]: {
            foreignKey: 'WB_ENTITY_ID',
            foreignKeyImmutable: true,
            localField: 'Entity'
        },
        [PASchema.esWB_AttributeType]: {
            foreignKey: 'WB_ATTRIBUTEM_ID',
            foreignKeyImmutable: true,
            localField: 'AttributeType'
        },
        [PASchema.esWB_Hierarchy_Level]: {
            foreignKey: 'WB_HIERARCHYLR_ID',
            foreignKeyImmutable: true,
            localField: 'HierarchyLevel'
        }
    }
}

export const WB_Hierarchy_Intelligent_Key = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_HierarchyIKR", // optional
    description: "Schema for WB_HierarchyIKR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_HIERARCHYIKR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_HIERARCHY_ID: {
            type: "number"
        },
        LEVEL_DEPTH: {
            type: "number"
        },
        START_DIGIT: {
            type: "number"
        },
        END_DIGIT: {
            type: "number"
        },
        WB_ENTITY_ID: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})

export const WB_Hierarchy_Intelligent_Key_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Hierarchy]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "Hierarchy"
        },
        [PASchema.esWB_Entity]: {
            foreignKey: "WB_ENTITY_ID",
            foreignKeyImmutable: true,
            localField: "Entity"
        }
    }
}

export const WB_Hierarchy_Export = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Hierarchy_Export", // optional
    description: "Schema for WB_Hierarchy_Export records", // optional
    type: "object",
    track: true,
    properties: {
        WB_HIERARCHY_EXPORT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_HIERARCHY_ID: {
            type: "number"
        },
        WB_ID_CHILD: {
            type: "number"
        },
        MAPPER_CHILD: {
            type: "string",
            length: 50
        },
        ID_UI_CHILD: {
            type: "string",
            length: 50
        },
        KEYSET_CHILD: {
            type: "string",
            length: 50
        },
        NAME_CHILD: {
            type: "string",
            length: 256
        },
        DEPTH_CHILD: {
            type: "number"
        },
        ID_EXTERNAL_CHILD: {
            type: "string",
            length: 516
        },
        WB_ID_PRNT: {
            type: "number"
        },
        MAPPER_PRNT: {
            type: "string",
            length: 50
        },
        ID_UI_PRNT: {
            type: "string",
            length: 50
        },
        KEYSET_PRNT: {
            type: "string",
            length: 50
        },
        NAME_PRNT: {
            type: "string",
            length: 256
        },
        ID_EXTERNAL_PRNT: {
            type: "string",
            default: "",
            length: 516
        },
        EFFECTIVE_START_DT: {
            type: "string",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            length: 8
        },
        REL_WB_ID: {
            type: "number"
        },
        REL_STATUS: {
            type: "string",
            length: 50
        },
        REL_ROW_ID: {
            type: "string",
            default: "",
            length: 50
        },
        REL_MODIFIED_DTTS: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})

export const WB_Hierarchy_Export_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Hierarchy]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "Hierarchy"
        }
    }
}

export const WB_Hierarchy_MDScope = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Customer_Hierarchy_SalesArea", // optional
    description: "Schema for WB_CustomerHSR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_HIERARCHYSCR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_HIERARCHY_ID: {
            type: "number"
        },
        ATTRIBUTE_ID: {
            type: "string",
            length: 50
        },
        ATTRIBUTE_TYPE: {
            type: "string",
            length: 256
        },
        OPERATION: {
            type: "string",
            length: 10
        },
        ATTRIBUTE_VALUES: {
            type: "string",
            length: 500
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Hierarchy_MDScope_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Hierarchy]: {
            foreignKey: "WB_HIERARCHY_ID",
            foreignKeyImmutable: true,
            localField: "Hierarchy"
        }
    }
}

// Label
export const WB_Label_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_LabelM", // optional
    description: "Schema for WB_LabelM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LABELM_ID: {
            type: "number",
            id: true,
            required: true
        },
        LABEL_TYPE_ID: {
            type: "string",
            default: "",
            length: 50
        },
        LABEL_TYPE_NAME: {
            type: "string",
            default: "",
            length: 256
        },
        SOURCE_TYPE: {
            type: "string",
            default: "",
            length: 50
        },
        EXAMPLE: {
            type: "string",
            default: "",
            length: 50
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    },
})
export const WB_Label_Type_JSData_RELs = {
    belongsTo: {}
}

export const WB_Label = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Label", // optional
    description: "Schema for WB_Label records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LABEL_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: "number",
            default: "0"
        },
        SOURCE_TYPE: {
            type: "string",
            default: "",
            length: 50
        },
        SOURCE_WB_ID: {
            type: "number",
            default: 0
        },
        LABEL_TYPE_ID: {
            type: "string",
            default: "",
            length: 50
        },
        LANGUAGE: {
            type: "string",
            default: "",
            length: 20
        },
        TEXT: {
            type: "string",
            default: "",
            length: 256
        },
        TOOLTIP: {
            type: "string",
            default: "",
            length: 256
        },
        MANUAL_IND: {
            type: "string",
            default: "",
            length: 1
        },
        CREATED_DTTS: {
            type: "number",
            default: 0
        },
        MODIFIED_DTTS: {
            type: "number",
            default: 0
        },
        DELETED_IND: {
            type: "string",
            default: "",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    },
})
export const WB_Label_JSData_RELs = {
    belongsTo: {}
}


//policy
export const WB_Policy_Area = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PolicyArea", // optional
    description: "Schema for WB_PolicyArea records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYAREA_ID: {
            type: "number",
            id: true,
            required: true
        },
        POLICYAREA_ID: {
            type: "string",
            length: 50
        },
        POLICYAREA_NAME: {
            type: "string",
            length: 256
        },
        COMMENTS: {
            type: "string",
            length: 1333
        },
        RESERVED_TERM_OPTIONS: {
            type: "string",
            length: 1333
        },
        BUSINESS_TYPE_OPTIONS: {
            type: "string",
            length: 1333
        },
        TERM_UOM_SHOW_IND: {
            type: "string",
            length: 1
        },
        USE_PROCEDURE_IND: {
            type: "string",
            length: 1
        },
        PROCEDURE_CALC_SHOW_IND: {
            type: "string",
            length: 1
        },
        PROCEDURE_CND_SHOW_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Policy_Area_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Policy_Term_Type]: {
            foreignKey: "WB_POLICYAREA_ID",
            foreignKeyImmutable: true,
            localField: "PolicyTermTypes"
        }
    }
}

export const WB_Policy_Term_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PolicyTermM", // optional
    description: "Schema for WB_PolicyTermM records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYTERMM_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_POLICYAREA_ID: {
            type: "number"
        },
        BUSINESS_TYPE: {
            type: "string",
            length: 50
        },
        TYPE_NAME: {
            type: "string",
            length: 256
        },
        INPUT_TYPE: {
            type: "string",
            length: 50
        },
        VALUE_TYPE: {
            type: "string",
            length: 50
        },
        TIME_MODE: {
            type: "string",
            length: 50
        },
        INPUT_STORAGE_POLICY: {
            type: "string",
            length: 50
        },
        INPUT_STORAGE_TYPE: {
            type: "string",
            length: 50
        },
        RESERVED_TERM_OPTIONS: {
            type: "string",
            length: 1333
        },
        PROCEDURE_REQUIREMENT: {
            type: "string",
            length: 50
        },
        BOLD_IND: {
            type: "string",
            length: 1
        },
        INDENT_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Policy_Term_Type_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_PolicyArea]: {
            foreignKey: "WB_POLICYAREA_ID",
            foreignKeyImmutable: true,
            localField: "PolicyArea"
        }
    }
}

export const WB_Tree = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Tree", // optional
    description: "Schema for WB_Tree records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TREE_ID: {
            type: "number",
            id: true,
            required: true
        },
        TREE_NAME: {
            type: "string",
            length: 255
        },
        WB_MDSET_ID: {
            type: "number"
        },
        WB_COMPANY_ID: {
            type: "number"
        },
        WB_SALESORG_ID: {
            type: "number"
        },
        SOURCE_TYPE: {
            type: "string",
            length: 50
        },
        SOURCE_WB_ID: {
            type: "number"
        },
        USER_IND: {
            type: "string",
            length: 1
        },
        WB_AUTHUSR_ID: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})

export const WB_Tree_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MDSet"
        },
        [PASchema.esWB_SalesOrg]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "SalesOrg"
        }
    },
    hasMany: {
        [PASchema.esWB_Tree_Folder]: {
            foreignKey: "WB_TREE_ID",
            foreignKeyImmutable: true,
            localField: "Folders"
        }
    }
}

export const WB_Tree_Folder = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Tree_Folder", // optional
    description: "Schema for WB_Tree_Folder records", // optional
    type: "object",
    track: true,
    properties: {
        WB_TREE_FOLDER_ID: {
            type: "number",
            id: true,
            required: true
        },
        FOLDER_NAME: {
            type: "string",
            length: 50
        },
        TREE_PATH: {
            type: "string",
            length: 256
        },
        WB_TREE_ID: {
            type: "number"
        },
        WB_TREE_FOLDER_ID_PRNT: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})

export const WB_Tree_Folder_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Tree]: {
            foreignKey: "WB_TREE_ID",
            foreignKeyImmutable: true,
            localField: "Tree"
        }
    }
}

export const WB_Policy = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Policy", // optional
    description: "Schema for WB_Policy records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICY_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_POLICYAREA_ID: {
            type: "number"
        },
        WB_MDSET_ID: {
            type: "number"
        },
        WB_SALESORG_ID: {
            type: "number"
        },
        POLICY_ID: {
            type: "string",
            length: 50
        },
        POLICY_NAME: {
            type: "string",
            length: 256
        },
        COMMENTS: {
            type: "string",
            length: 1333
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EVENT_STATUS_CSV: {
            type: "string",
            length: 1000
        },
        TACTIC_STATUS_CSV: {
            type: "string",
            length: 1000
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})

export const WB_Policy_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MDSet"
        },
        [PASchema.esWB_SalesOrg]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "SalesOrg"
        },
        [PASchema.esWB_PolicyArea]: {
            foreignKey: "WB_POLICYAREA_ID",
            foreignKeyImmutable: true,
            localField: "PolicyArea"
        }
    },
    hasMany: {
        [PASchema.esWB_Policy_SalesArea]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "PolicySalesAreas"
        },
        [PASchema.esWB_Policy_FundType]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "PolicyFundTypes"
        },
        [PASchema.esWB_Policy_Term]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "PolicyTerms"
        },
        [PASchema.esWB_Policy_Procedure]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "PolicyProcedures"
        },
        [PASchema.esWB_Policy_Cube]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "PolicyCubes"
        },
        [PASchema.esWB_Policy_SpendType_TermR]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "PolicySpendTypeTermRs"
        }
    }
}

export const WB_Policy_SalesArea = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Policy_SalesArea", // optional
    description: "Schema for WB_PolicySAR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYSAR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_POLICY_ID: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        MANUAL_IND: {
            type: "string",
            length: 1
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Policy_SalesArea_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_SalesArea]: {
            foreignKey: "WB_SALESAREA_ID",
            foreignKeyImmutable: true,
            localField: "SalesArea"
        },
        [PASchema.esWB_Policy]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "Policy"
        }
    }
}

export const WB_Policy_FundType = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Policy_FundType", // optional
    description: "Schema for WB_PolicyFTR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYFTR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_POLICY_ID: {
            type: "number"
        },
        WB_FUNDTYPE_ID: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Policy_FundType_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Fund_Type]: {
            foreignKey: "WB_FUNDTYPE_ID",
            foreignKeyImmutable: true,
            localField: "FundType"
        },
        [PASchema.esWB_Policy]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "Policy"
        }
    }
}


export const WB_Policy_SpendType_TermR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PolicySpendTypeTermR", // optional
    description: "Schema for WB_PolicySpendTypeTermR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYSPENDTYPETERMR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_POLICY_ID: {
            type: "number"
        },
        WB_EVTSTYPE_ID: {
            type: "number"
        },
        RATE_BASIS: {
            type: "string",
            length: 50
        },
        RATE_UOM_IDS: {
            type: "string",
            length: 500
        },
        PAYMENT_METHOD_IDS: {
            type: "string",
            length: 500
        },
        WB_POLICYTERM_ID: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Policy_SpendType_TermR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Policy]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "Policy"
        }
    }
}

export const WB_Policy_Term = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Policy_Term", // optional
    description: "Schema for WB_Policy_Term records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYTERM_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_POLICY_ID: {
            type: "number"
        },
        WB_FUNDTYPE_ID: {
            type: "number"
        },
        TERM_NAME: {
            type: "string",
            length: 256
        },
        WB_POLICY_TERMM_ID: {
            type: "number"
        },
        RATE_UOM: {
            type: "string",
            length: 20
        },
        RESERVED_TERM_ID: {
            type: "string",
            length: 50
        },
        CNDM_ENTERPRISE_SET_ID: {
            type: "string",
            length: 50
        },
        PRD_CNDM_ID: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Policy_Term_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Policy]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "Policy"
        },
        [PASchema.esWB_Fund_Type]: {
            foreignKey: "WB_FUNDTYPE_ID",
            foreignKeyImmutable: true,
            localField: "FundType"
        },
        [PASchema.esWB_Policy_Term_Type]: {
            foreignKey: "WB_POLICY_TERMM_ID",
            foreignKeyImmutable: true,
            localField: "PolicyTermType"
        },
        [PASchema.esWB_Product_Condition_Type]: {
            foreignKey: "PRD_CNDM_ID",
            foreignKeyImmutable: true,
            localField: "ProductConditionType"
        }
    }
}

export const WB_Policy_Procedure = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PolicyPLR", // optional
    description: "Schema for WB_PolicyPLR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYPLR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_POLICY_ID: {
            type: "number"
        },
        WB_FUNDTYPE_ID: {
            type: "number"
        },
        LINE_ID: {
            type: "string",
            length: 50
        },
        WB_POLICYTERM_ID: {
            type: "number"
        },
        CALCULATION_TYPE_ID: {
            type: "string",
            length: 50
        },
        LINE_ID_REFLINE: {
            type: "string",
            length: 50
        },
        CUST_CND_IND: {
            type: "string",
            length: 1
        },
        WB_ATTRIBUTEM_ID_CUST_CND: {
            type: "number"
        },
        CUST_CND_VALUE: {
            type: "string",
            length: 50
        },
        INHERIT_BOM_IND: {
            type: "string",
            length: 1
        },
        MULTIPLE_VALUE_POLICY: {
            type: "string",
            length: 50
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_Policy_Procedure_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Policy]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "Policy"
        },
        [PASchema.esWB_Fund_Type]: {
            foreignKey: "WB_FUNDTYPE_ID",
            foreignKeyImmutable: true,
            localField: "FundType"
        },
        [PASchema.esWB_Policy_Term]: {
            foreignKey: "WB_POLICYTERM_ID",
            foreignKeyImmutable: true,
            localField: "PolicyTerm"
        }
    }
}

export const WB_Policy_Cube = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PolicyCube", // optional
    description: "Schema for WB_PolicyCube records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYCUBE_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_POLICY_ID: {
            type: "number"
        },
        WB_ENTITY_ID_CUSTOMER: {
            type: "number"
        },
        WB_ENTITY_ID_PRODUCT: {
            type: "number"
        },
        WB_ENTITY_ID_PERIOD: {
            type: "number"
        },
        WB_POLICYCUBE_ID_SRC: {
            type: "number"
        },
        WB_POLICYCUBEPROCESS_ID: {
            type: "number"
        },
        CUBE_ID: {
            type: "string",
            length: 50
        },
        CUBE_NAME: {
            type: "string",
            length: 256
        },
        CUBE_TYPE: {
            type: "string",
            length: 50
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Policy_Cube_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Policy]: {
            foreignKey: "WB_POLICY_ID",
            foreignKeyImmutable: true,
            localField: "Policy"
        },
        [PASchema.esWB_Policy_Cube_Process]: {
            foreignKey: "WB_POLICYCUBEPROCESS_ID",
            foreignKeyImmutable: true,
            localField: "PolicyCubeProcess"
        }
    },
    hasMany: {
        [PASchema.esWB_Policy_Cube_TermR]: {
            foreignKey: "WB_POLICYCUBE_ID",
            foreignKeyImmutable: true,
            localField: "PolicyCubeTerms"
        }
    }
}

export const WB_Policy_Cube_Term = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PolicyCubeTR", // optional
    description: "Schema for WB_PolicyCubeTR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYCUBETR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_POLICYCUBE_ID: {
            type: "number"
        },
        WB_POLICYTERM_ID: {
            type: "number"
        },
        EFFECTIVE_DATE_POLICY: {
            type: "string",
            length: 50
        },
        WB_CUSTH_ID: {
            type: "number"
        },
        WB_PRDH_ID: {
            type: "number"
        },
        MULTIPLE_CONDITION_POLICY: {
            type: "string",
            length: 50
        },
        PRD_CNDM_ID: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Policy_Cube_Term_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Policy_Cube]: {
            foreignKey: "WB_POLICYCUBE_ID",
            foreignKeyImmutable: true,
            localField: "PolicyCube"
        },
        [PASchema.esWB_Policy_Term]: {
            foreignKey: "WB_POLICYTERM_ID",
            foreignKeyImmutable: true,
            localField: "PolicyTerm"
        },
        [PASchema.esWB_Product_Condition_Type]: {
            foreignKey: "PRD_CNDM_ID",
            foreignKeyImmutable: true,
            localField: "ProductConditionType"
        }
    }
}

export const WB_Policy_Cube_Process = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PolicyCubeProcess", // optional
    description: "Schema for WB_PolicyCubeProcess records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYCUBEPROCESS_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_MDSET_ID: {
            type: "number"
        },
        WB_SALESORG_ID: {
            type: "number"
        },
        WB_ENTITY_ID_CUSTOMER_SRC: {
            type: "number"
        },
        WB_ENTITY_ID_PRODUCT_SRC: {
            type: "number"
        },
        WB_ENTITY_ID_PERIOD_SRC: {
            type: "number"
        },
        WB_ENTITY_ID_CUSTOMER_TGT: {
            type: "number"
        },
        WB_ENTITY_ID_PRODUCT_TGT: {
            type: "number"
        },
        WB_ENTITY_ID_PERIOD_TGT: {
            type: "number"
        },
        PROCESS_ID: {
            type: "string",
            length: 50
        },
        PROCESS_NAME: {
            type: "string",
            length: 256
        },
        COMMENTS: {
            type: "string",
            length: 1000
        },
        EXEC_OPTIONS: {
            type: "string",
            length: 1000
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Policy_Cube_Process_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" },
        [PASchema.esWB_SalesOrg]: { foreignKey: "WB_SALESORG_ID", foreignKeyImmutable: true, localField: "SalesOrg" },
        [PASchema.esWB_Entity]: [
            { foreignKey: "WB_ENTITY_ID_CUSTOMER_SRC", foreignKeyImmutable: true, localField: "CustomerSource" },
            { foreignKey: "WB_ENTITY_ID_CUSTOMER_TGT", foreignKeyImmutable: true, localField: "CustomerTarget" },
            { foreignKey: "WB_ENTITY_ID_PRODUCT_SRC", foreignKeyImmutable: true, localField: "ProductSource" },
            { foreignKey: "WB_ENTITY_ID_PRODUCT_TGT", foreignKeyImmutable: true, localField: "ProductTarget" },
            { foreignKey: "WB_ENTITY_ID_PERIOD_SRC", foreignKeyImmutable: true, localField: "PeriodSource" },
            { foreignKey: "WB_ENTITY_ID_PERIOD_TGT", foreignKeyImmutable: true, localField: "PeriodTarget" }
        ]
    },
    hasMany: {
        [PASchema.esWB_Policy_Cube_ProcessR]: {
            foreignKey: "WB_POLICYCUBEPROCESS_ID",
            foreignKeyImmutable: true,
            localField: "PolicyCubeProcessRels"
        }
    }
}

export const WB_Policy_Cube_ProcessR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PolicyCubeProcessR", // optional
    description: "Schema for WB_PolicyCubeProcessR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYCUBEPROCESSR_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_POLICYCUBEPROCESS_ID: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        WB_CUST_ID_SRC: {
            type: "number"
        },
        WB_PRD_ID_SRC: {
            type: "number"
        },
        WB_PERIOD_ID_SRC: {
            type: "number"
        },
        WB_CUST_ID_TGT: {
            type: "number"
        },
        WB_PRD_ID_TGT: {
            type: "number"
        },
        WB_PERIOD_ID_TGT: {
            type: "number"
        },
        ALLOCATION_PCNT: {
            type: "number"
        },
        OVRD_AMT: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        DELETED_IND: {
            type: "string",
            length: 1
        }
    }
})
export const WB_Policy_Cube_ProcessR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Policy_Cube_Process]: {
            foreignKey: "WB_POLICYCUBEPROCESS_ID",
            foreignKeyImmutable: true,
            localField: "PolicyCubeProcess"
        }
    }
}

export const WB_Policy_Term_Value = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_PolicyTermValue", // optional
    description: "Schema for WB_PolicyTermValue records", // optional
    type: "object",
    track: true,
    properties: {
        WB_POLICYTERMVALUE_ID: {
            type: "number",
            id: true,
            required: true
        },
        USAGE: {
            type: "string",
            length: 50
        },
        REFERENCE_TYPE: {
            type: "string",
            length: 50
        },
        WB_ID_REF: {
            type: "number"
        },
        WB_FUNDTYPE_ID: {
            type: "number"
        },
        WB_POLICYTERM_ID: {
            type: "number"
        },
        WB_POLICYCUBE_ID: {
            type: "number"
        },
        WB_POLICYPLR_ID: {
            type: "number"
        },
        STEP: {
            type: "number"
        },
        WB_ENTITY_ID_CUSTOMER: {
            type: "number"
        },
        WB_ENTITY_ID_PRODUCT: {
            type: "number"
        },
        WB_CUST_ID: {
            type: "number"
        },
        WB_PROD_ID: {
            type: "number"
        },
        WB_PRDGRP_ID: {
            type: "number"
        },
        WB_SALESORG_ID: {
            type: "number"
        },
        WB_SALESAREA_ID: {
            type: "number"
        },
        EFFECTIVE_START_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        EFFECTIVE_END_DT: {
            type: "string",
            default: "18000101",
            length: 8
        },
        VALUE_NORMALIZED: {
            type: "number"
        },
        VALUE_RUNNING: {
            type: "number"
        },
        VALUE_UOM: {
            type: "string",
            length: 50
        },
        VALUE_CONDITION: {
            type: "number"
        },
        WB_EVTS_ID: {
            type: "number"
        },
        WB_EVTSPG_ID: {
            type: "number"
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})

export const WB_Policy_Term_Value_JSData_RELs = {
    belongsTo: {},
    hasMany: {}
}

export const WB_Product_Condition_Type_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Prod_CndMT", // optional
    description: "Schema for Prod_CndMT records", // optional
    type: "object",
    track: true,
    properties: {
        PROD_CNDMT_ID: {
            type: "number",
            default: "",
            id: true,
            required: true
        },
        PRD_CNDM_ID: {
            type: "number",
            default: ""
        },
        LANGUAGE: {
            type: "string",
            default: "",
            length: 50
        },
        TEXT: {
            type: "string",
            default: "",
            length: 256
        },
        SHORTTEXT: {
            type: "string",
            default: "",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            default: null,
            length: 50
        },
        TOOLTIP: {
            type: "string",
            default: "",
            length: 256
        }
    }
})
export const WB_Product_Condition_Type_Text_JSData_RELs = {}

export const WB_General_Ledger_Account_Text = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_GLAcctT", // optional
    description: "Schema for WB_GLAcctT records", // optional
    type: "object",
    track: true,
    properties: {
        WB_GLACCTT_ID: {
            type: "number",
            id: true,
            required: true
        },
        WB_GLACCT_ID: {
            type: "number"
        },
        LANGUAGE: {
            type: "string",
            length: 20
        },
        TEXT: {
            type: "string",
            length: 256
        },

        SHORTTEXT: {
            type: "string",
            length: 256
        },
        ABBREVIATION: {
            type: "string",
            length: 50
        },
        TOOLTIP: {
            type: "string",
            length: 256
        },
        CREATED_DTTS: {
            type: "number"
        },
        MODIFIED_DTTS: {
            type: "number"
        },
        DELETED_IND: {
            type: "string",
            length: 1
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8
        }
    }
})
export const WB_General_Ledger_Account_Text_JSData_RELs = {}


//Funding Rules
export const WB_FundingRule = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_FundingRule", // optional
    description: "Schema for WB_FundingRule records", // optional
    type: "object",
    track: true,
    "properties": {
        "WB_FUNDINGRULE_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "FUNDING_RULE_ID": {
            "type": "string",
            "length": 50
        },
        "FUNDING_RULE_NAME": {
            "type": "string",
            "length": 256
        },
        "WB_MDSET_ID": {
            "type": "number"
        },
        "WB_SALESORG_ID": {
            "type": "number"
        },
        "EFFECTIVE_START_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "EFFECTIVE_END_DT": {
            "type": "string",
            "default": "99991231",
            "length": 8
        },
        "RULE_TYPE": {
            "type": "string",
            "length": 50
        },
        "WB_FUNDTYPE_ID": {
            "type": "number"
        },
        "RULE_PROCESS_MODE": {
            "type": "string",
            "length": 10
        },
        "ACTUALS_THRU_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        },
        "FORECAST_START_DT": {
            "type": "string",
            "default": "99991231",
            "length": 8
        },
        "FUNDINGACCOUNT_TYPE": {
            "type": "string",
            "length": 10
        },
        "WB_FUNDINGACCOUNT_ID": {
            "type": "number"
        },
        "WB_ENTITY_ID_PRODUCT": {
            "type": "number"
        },
        "WB_AUTHUSR_ID_CREATEDBY": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
})
export const WB_FundingRule_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: {
            foreignKey: "WB_MDSET_ID",
            foreignKeyImmutable: true,
            localField: "MDSet"
        },
        [PASchema.esWB_SalesOrg]: {
            foreignKey: "WB_SALESORG_ID",
            foreignKeyImmutable: true,
            localField: "SalesOrg"
        },
        [PASchema.esWB_Funding_Account]: {
            foreignKey: "WB_FUNDINGACCOUNT_ID",
            foreignKeyImmutable: true,
            localField: "FundingAccountSource"
        },
        [PASchema.esWB_Fund_Type]: {
            foreignKey: "WB_FUNDTYPE_ID",
            foreignKeyImmutable: true,
            localField: "FundType"
        }
        /*  [PASchema.esWB_Entity]: {
              foreignKey: "WB_ENTITY_ID_PRODUCT",
              foreignKeyImmutable: true,
              localField: "FundingRuleScopeLevel",
          }*/
    },
    hasMany: {
        [PASchema.esWB_Funding_Rule_Set]: {
            foreignKey: "WB_FUNDINGRULE_ID",
            foreignKeyImmutable: true,
            localField: "FundingRuleSets"
        }
    }
}

export const WB_FundingRuleSet = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_FundingRuleSet", // optional
    description: "Schema for WB_FundingRuleSet records", // optional
    type: "object",
    track: true,
    "properties": {
        "WB_FUNDINGRULESET_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_FUNDINGRULE_ID": {
            "type": "number"
        },
        "ACTIVE_IND": {
            "type": "string",
            "length": 1
        },
        "VALID_THRU": {
            "type": "string",
            "default": "99991231",
            "length": 8
        },
        "RULE_TYPE": {
            "type": "string",
            "length": 50
        },
        "WB_AUTHUSR_ID_CREATEDBY": {
            "type": "number"
        },
        "WB_AUTHUSR_ID_LASTMODIFIED": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
})
export const WB_FundingRuleSet_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Funding_Rule]: {
            foreignKey: "WB_FUNDINGRULE_ID",
            foreignKeyImmutable: true,
            localField: "FundingRule"
        },
        [PASchema.esWB_User]: {
            foreignKey: "WB_AUTHUSR_ID_LASTMODIFIED",
            foreignKeyImmutable: true,
            localField: "User"
        }
    },
    hasMany: {
        [PASchema.esWB_Funding_Rule_Set_Relationship]: {
            foreignKey: "WB_FUNDINGRULESET_ID",
            foreignKeyImmutable: true,
            localField: "FundingRuleSetRelationships"
        }
    }
}

export const WB_FundingRuleSetR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_FundingRuleSetR", // optional
    description: "Schema for WB_FundingRuleSetR records", // optional
    type: "object",
    track: true,
    "properties": {
        "WB_FUNDINGRULESETR_ID": {
            "type": "number",
            "id": true,
            "required": true
        },
        "WB_FUNDINGRULESET_ID": {
            "type": "number"
        },
        "WB_PRDGRP_ID": {
            "type": "number"
        },
        "PARTITION": {
            "type": "string",
            "length": 50
        },
        "WB_FUNDINGACCOUNT_ID": {
            "type": "number"
        },
        "ALLOCATION_PCNT": {
            "type": "number"
        },
        "CREATED_DTTS": {
            "type": "number"
        },
        "MODIFIED_DTTS": {
            "type": "number"
        },
        "DELETED_IND": {
            "type": "string",
            "length": 1
        },
        "DELETED_DT": {
            "type": "string",
            "default": "18000101",
            "length": 8
        }
    }
})
export const WB_FundingRuleSetR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Funding_Rule_Set]: {
            foreignKey: "WB_FUNDINGRULESET_ID",
            foreignKeyImmutable: true,
            localField: "FundingRuleSet"
        },
        [PASchema.esWB_Funding_Account]: {
            foreignKey: "WB_FUNDINGACCOUNT_ID",
            foreignKeyImmutable: true,
            localField: "FundingAccount"
        }
    }
}

_.defaults(dctSchemaByEntitySet, {
    [PASchema.esWB_Company]: WB_Company,
    [PASchema.esWB_Company_Text]: WB_Company_Text,
    [PASchema.esWB_Consumer_Product_Alignment]: WB_Consumer_Product_Alignment,
    [PASchema.esWB_Consumer_Product_Customer_Alignment]: WB_Consumer_Product_Customer_Alignment,
    [PASchema.esWB_Consumption_Product]: WB_Consumption_Product,
    [PASchema.esWB_Consumption_Product_Group]: WB_Consumption_Product_Group,
    [PASchema.esWB_Currency]: WB_Currency,
    [PASchema.esWB_CurrencyT]: WB_CurrencyT,
    [PASchema.esWB_Customer]: WB_Customer,
    [PASchema.esWB_Customer_Attribute]: WB_Customer_Attribute,
    [PASchema.esWB_Customer_Bill_To_Relationship]: WB_Customer_Bill_To_Relationship,
    [PASchema.esWB_Customer_Pay_To_Relationship]: WB_Customer_Pay_To_Relationship,
    [PASchema.esWB_Customer_Calendar]: WB_Customer_Calendar,
    [PASchema.esWB_Customer_Distribution_Relationship]: WB_Customer_Distribution_Relationship,
    [PASchema.esWB_Customer_External_Relationship]: WB_Customer_External_Relationship,
    [PASchema.esWB_Customer_Hierarchy]: WB_Customer_Hierarchy,
    [PASchema.esWB_Customer_Hierarchy_SalesArea]: WB_Customer_Hierarchy_SalesArea,
    [PASchema.esWB_Customer_Hierarchy_Level]: WB_Customer_Hierarchy_Level,
    [PASchema.esWB_Customer_LogicalKey]: WB_Customer_LogicalKey,
    [PASchema.esWB_Customer_Product]: WB_Customer_Product,
    [PASchema.esWB_Customer_Proxy_Relationship]: WB_Customer_Proxy_Relationship,
    [PASchema.esWB_Customer_Relationship]: WB_Customer_Relationship,
    [PASchema.esWB_Customer_Tag_Relationship]: WB_Customer_Tag_Relationship,
    [PASchema.esWB_Customer_Type]: WB_Customer_Type,
    [PASchema.esWB_Customer_Role]: WB_Customer_Role,
    [PASchema.esWB_Customer_SalesArea_Relationship]: WB_Customer_SalesArea,
    [PASchema.esWB_Customer_Role_Relationship]: WB_Customer_Role_Relationship,
    [PASchema.esWB_Customer_Role_Customer_Relationship]: WB_Customer_Role_Customer_Relationship,
    [PASchema.esWB_Division]: WB_Division,
    [PASchema.esWB_Division_Text]: WB_Division_Text,
    [PASchema.esWB_DistribChannel]: WB_DistribChannel,
    [PASchema.esWB_DistribChannel_Text]: WB_DistribChannel_Text,
    [PASchema.esWB_Finished_Product]: WB_Finished_Product,
    [PASchema.esWB_Finished_Product_SalesArea]: WB_Finished_Product_SalesArea,
    [PASchema.esWB_Finished_Product_Relationship]: WB_Finished_Product_Relationship,
    [PASchema.esWB_Finished_Product_Tag_Relationship]: WB_Finished_Product_Tag_Relationship,
    [PASchema.esWB_MasterData_Set]: WB_MasterData_Set,
    [PASchema.esWB_Period]: WB_Period,
    [PASchema.esWB_Period_Attribute]: WB_Period_Attribute,
    [PASchema.esWB_Period_Hierarchy]: WB_Period_Hierarchy,
    [PASchema.esWB_Period_Hierarchy_Level]: WB_Period_Hierarchy_Level,
    [PASchema.esWB_Period_Relationship]: WB_Period_Relationship,
    [PASchema.esWB_Period_Tag_Relationship]: WB_Period_Tag_Relationship,
    [PASchema.esWB_Period_Type]: WB_Period_Type,
    [PASchema.esWB_Period_Company_Relationship]: WB_Period_Company_Relationship,
    [PASchema.esWB_Period_Hierarchy_Company_Relationship]: WB_Period_Hierarchy_Company_Relationship,
    [PASchema.esWB_Product_Attribute]: WB_Product_Attribute,
    [PASchema.esWB_Product_Attribute_Group]: WB_Product_Attribute_Group,
    [PASchema.esWB_Product_Attribute_Group_Relationship]: WB_Product_Attribute_Group_Relationship,
    [PASchema.esWB_Product_Attribute_Map]: WB_Product_Attribute_Map,
    [PASchema.esWB_Product_Attribute_Map_External_Relationship]: WB_Product_Attribute_Map_External_Relationship,
    [PASchema.esWB_Product_Attribute_Map_Value_Relationship]: WB_Product_Attribute_Map_Value_Relationship,
    [PASchema.esWB_Product_BOM]: WB_Product_BOM,
    [PASchema.esWB_Product_BOM_Component]: WB_Product_BOM_Component,
    [PASchema.esWB_Product_Group]: WB_Product_Group,
    [PASchema.esWB_Product_Group_SalesArea]: WB_Product_Group_SalesArea,
    [PASchema.esWB_Product_Group_LogicalKey]: WB_Product_Group_LogicalKey,
    [PASchema.esWB_Product_Group_Attribute]: WB_Product_Group_Attribute,
    [PASchema.esWB_Product_Group_External_Relationship]: WB_Product_Group_External_Relationship,
    [PASchema.esWB_Product_Group_Relationship]: WB_Product_Group_Relationship,
    [PASchema.esWB_Product_Group_Tag_Relationship]: WB_Product_Group_Tag_Relationship,
    [PASchema.esWB_Product_Group_UOM]: WB_Product_Group_UOM,
    [PASchema.esWB_Product_Hierarchy]: WB_Product_Hierarchy,
    [PASchema.esWB_Product_Hierarchy_SalesArea]: WB_Product_Hierarchy_SalesArea,
    [PASchema.esWB_Product_Hierarchy_Level]: WB_Product_Hierarchy_Level,
    [PASchema.esWB_Product_Type]: WB_Product_Type,
    [PASchema.esWB_Product_UOM]: WB_Product_UOM,
    [PASchema.esWB_SalesOrg]: WB_SalesOrg,
    [PASchema.esWB_SalesOrg_Text]: WB_SalesOrg_Text,
    [PASchema.esWB_SalesArea]: WB_SalesArea,
    [PASchema.esWB_SalesArea_Text]: WB_SalesArea_Text,
    [PASchema.esWB_Set]: WB_Sets,
    [PASchema.esWB_SourceType]: WB_SourceType,
    [PASchema.esWB_SourceTypeSTR]: WB_SourceTypeSTR,
    [PASchema.esWB_Source]: WB_Source,
    [PASchema.esWB_Source_SetType]: WB_Source_SetType,
    [PASchema.esWB_UOM]: WB_UOM,
    [PASchema.esWB_Hierarchy]: WB_Hierarchy,
    [PASchema.esWB_Hierarchy_Level]: WB_Hierarchy_Level,
    [PASchema.esWB_Hierarchy_Period]: WB_Hierarchy_Period,
    [PASchema.esWB_Hierarchy_SalesArea]: WB_Hierarchy_SalesArea,
    [PASchema.esWB_Hierarchy_Entity_Generation]: WB_Hierarchy_Entity_Generation,
    [PASchema.esWB_Hierarchy_Attribute_Generation]: WB_Hierarchy_Attribute_Generation,
    [PASchema.esWB_Hierarchy_Intelligent_Key]: WB_Hierarchy_Intelligent_Key,
    [PASchema.esWB_Hierarchy_Export]: WB_Hierarchy_Export,
    [PASchema.esWB_Hierarchy_MDScope]: WB_Hierarchy_MDScope,
    [PASchema.esWB_Label_Type]: WB_Label_Type,
    [PASchema.esWB_Label]: WB_Label,
    [PASchema.esWB_Policy]: WB_Policy,
    [PASchema.esWB_Policy_SalesArea]: WB_Policy_SalesArea,
    [PASchema.esWB_Policy_FundType]: WB_Policy_FundType,
    [PASchema.esWB_PolicyArea]: WB_Policy_Area,
    [PASchema.esWB_Policy_Procedure]: WB_Policy_Procedure,
    [PASchema.esWB_Policy_Cube]: WB_Policy_Cube,
    [PASchema.esWB_Policy_Cube_TermR]: WB_Policy_Cube_Term,
    [PASchema.esWB_Policy_Cube_Process]: WB_Policy_Cube_Process,
    [PASchema.esWB_Policy_Cube_ProcessR]: WB_Policy_Cube_ProcessR,
    [PASchema.esWB_Policy_Term_Value]: WB_Policy_Term_Value,
    [PASchema.esWB_Product_Condition_Type_Text]: WB_Product_Condition_Type_Text,
    [PASchema.esWB_General_Ledger_Account_Text]: WB_General_Ledger_Account_Text,
    [PASchema.esWB_Product_Group_Text]: WB_Product_Group_Text,
    [PASchema.esWB_Finished_Product_Text]: WB_Finished_Product_Text,
    [PASchema.esWB_UOM_Text]: WB_UOM_Text,
    [PASchema.esWB_Product_Hierarchy_Text]: WB_Product_Hierarchy_Text,
    [PASchema.esWB_Customer_Hierarchy_Text]: WB_Customer_Hierarchy_Text,
    [PASchema.esWB_CustomerCR]: WB_CustomerCR,
    [PASchema.esWB_CustomerSAR]: WB_CustomerSAR,
    [PASchema.esWB_Policy_SpendType_TermR]: WB_Policy_SpendType_TermR,
    [PASchema.esWB_Funding_Rule]: WB_FundingRule,
    [PASchema.esWB_Funding_Rule_Set]: WB_FundingRuleSet,
    [PASchema.esWB_Funding_Rule_Set_Relationship]: WB_FundingRuleSetR,
    [PASchema.esWB_External_Product_RelationShip]: WB_External_Product_Relationship
})

// These tables need to be moved into the JSData Schemas
_.defaults(dctTableNameByEntitySet, {
    [PASchema.esWB_Consumer_Product_Alignment]: '/AZR/WB_UPCPRDR',
    [PASchema.esWB_Consumer_Product_Customer_Alignment]: '/AZR/WB_UPCPRDPR',
    [PASchema.esWB_Consumption_Product]: '/AZR/WB_CNSPRD',
    [PASchema.esWB_Consumption_Product_Group]: '/AZR/WB_CNSPG',
    [PASchema.esWB_Company]: '/AZR/WB_COMPANY',
    [PASchema.esWB_Company_Text]: '/AZR/WB_COMPANYT',
    [PASchema.esWB_Currency]: '/AZR/WB_CURRENCY',
    [PASchema.esWB_CurrencyT]: '/AZR/WB_CURRENCYT',
    [PASchema.esWB_Customer]: '/AZR/WB_CUST',
    [PASchema.esWB_Customer_Bill_To_Relationship]: '/AZR/WB_CUST_BILL_TO_REL',
    [PASchema.esWB_Customer_Pay_To_Relationship]: '/AZR/WB_CUST_PAY_TO_REL',
    [PASchema.esWB_Customer_Calendar]: '/AZR/WB_CUSTCAL',
    [PASchema.esWB_Customer_Attribute]: '/AZR/WB_CUSTATTR',
    [PASchema.esWB_Customer_Distribution_Relationship]: '/AZR/WB_CUSTRPG',
    [PASchema.esWB_Customer_External_Relationship]: '/AZR/WB_EXTCUSTR',
    [PASchema.esWB_Customer_Hierarchy]: '/AZR/WB_CUSTH',
    [PASchema.esWB_Customer_Hierarchy_SalesArea]: '/AZR/WB_CUSTHSR',
    [PASchema.esWB_Customer_Hierarchy_Level]: '/AZR/WB_CUSTH_LEVEL',
    [PASchema.esWB_Customer_LogicalKey]: '/AZR/WB_CUSTLKR',
    [PASchema.esWB_Customer_Product]: '/AZR/WB_CUSTPRDR',
    [PASchema.esWB_Customer_Proxy_Relationship]: '/AZR/WB_EXTCUSTP',
    [PASchema.esWB_Customer_Relationship]: '/AZR/WB_CUSTR',
    [PASchema.esWB_Customer_Tag_Relationship]: '/AZR/WB_CUST_TAGR',
    [PASchema.esWB_Customer_Role]: '/AZR/WB_CUSTROLE',
    [PASchema.esWB_Customer_Type]: '/AZR/WB_CUSTM',
    [PASchema.esWB_Customer_SalesArea_Relationship]: '/AZR/WB_CUSTSR',
    [PASchema.esWB_Customer_Role_Relationship]: '/AZR/WB_CUSTRSR',
    [PASchema.esWB_Customer_Role_Customer_Relationship]: '/AZR/WB_CUSTRSCR',
    [PASchema.esWB_DistribChannel]: '/AZR/WB_DISTRIBCHANNEL',
    [PASchema.esWB_DistribChannel_Text]: '/AZR/WB_DISTRIBCHANNELT',
    [PASchema.esWB_Division]: '/AZR/WB_DIVISION',
    [PASchema.esWB_Division_Text]: '/AZR/WB_DIVISIONT',
    [PASchema.esWB_Finished_Product]: '/AZR/WB_PROD',
    [PASchema.esWB_Finished_Product_SalesArea]: '/AZR/WB_PRODSR',
    [PASchema.esWB_Finished_Product_Relationship]: '/AZR/WB_PRODR',
    [PASchema.esWB_Finished_Product_Tag_Relationship]: '/AZR/WB_PROD_TAGR',
    [PASchema.esWB_MasterData_Set]: '/AZR/WB_MDSET',
    [PASchema.esWB_Period]: '/AZR/WB_PERIOD',
    [PASchema.esWB_Period_Attribute]: '/AZR/WB_PERIODATTR',
    [PASchema.esWB_Period_Hierarchy]: '/AZR/WB_PERIODH',
    [PASchema.esWB_Period_Hierarchy_Level]: '/AZR/WB_PERIODH_LEVEL',
    [PASchema.esWB_Period_Relationship]: '/AZR/WB_PERIODR',
    [PASchema.esWB_Period_Tag_Relationship]: '/AZR/WB_PERIOD_TAGR',
    [PASchema.esWB_Period_Type]: '/AZR/WB_PERIODM',
    [PASchema.esWB_Period_Company_Relationship]: '/AZR/WB_PERIODCR',
    [PASchema.esWB_Period_Hierarchy_Company_Relationship]: '/AZR/WB_PERIODHCR',
    [PASchema.esWB_Product_Attribute]: '/AZR/WB_PRDATTR',
    [PASchema.esWB_Product_Attribute_Group]: '/AZR/WB_PRDATTRGRP',
    [PASchema.esWB_Product_Attribute_Group_Relationship]: '/AZR/WB_PRDATTRGRPR',
    [PASchema.esWB_Product_Attribute_Map]: '/AZR/WB_PRDATTRMAP',
    [PASchema.esWB_Product_Attribute_Map_External_Relationship]: '/AZR/WB_PRDATTRMAP_EXTR',
    [PASchema.esWB_Product_Attribute_Map_Value_Relationship]: '/AZR/WB_PRDATTRMAP_VALUER',
    [PASchema.esWB_Product_BOM]: '/AZR/WB_PROD_BOM',
    [PASchema.esWB_Product_BOM_Component]: '/AZR/WB_PROD_BOM_COMP',
    [PASchema.esWB_Product_Group]: '/AZR/WB_PRDGRP',
    [PASchema.esWB_Product_Group_SalesArea]: '/AZR/WB_PRDGRPSR',
    [PASchema.esWB_Product_Group_LogicalKey]: '/AZR/WB_PRDGRPLKR',
    [PASchema.esWB_Product_Group_Attribute]: '/AZR/WB_PRDGRPAR',
    [PASchema.esWB_Product_Group_External_Relationship]: '/AZR/WB_PRDGRP_EXTR',
    [PASchema.esWB_Product_Group_Relationship]: '/AZR/WB_PRDGRPR',
    [PASchema.esWB_Product_Group_Tag_Relationship]: '/AZR/WB_PRDGRP_TAGR',
    [PASchema.esWB_Product_Group_UOM]: '/AZR/WB_PRDGRP_UOM',
    [PASchema.esWB_Product_Hierarchy]: '/AZR/WB_PRDH',
    [PASchema.esWB_Product_Hierarchy_SalesArea]: '/AZR/WB_PRDHSR',
    [PASchema.esWB_Product_Hierarchy_Level]: '/AZR/WB_PRDH_LEVEL',
    [PASchema.esWB_Product_Type]: '/AZR/WB_PRDM',
    [PASchema.esWB_Product_UOM]: '/AZR/WB_PROD_UOM',
    [PASchema.esWB_SalesOrg]: '/AZR/WB_SALESORG',
    [PASchema.esWB_SalesOrg_Text]: '/AZR/WB_SALESORGT',
    [PASchema.esWB_SalesArea]: '/AZR/WB_SALESAREA',
    [PASchema.esWB_SalesArea_Text]: '/AZR/WB_SALESAREAT',
    [PASchema.esWB_Set]: '/AZR/SETS',
    [PASchema.esWB_Source]: '/AZR/SOURCE',
    [PASchema.esWB_Source_SetType]: '/AZR/SOURCESR',
    [PASchema.esWB_SourceType]: '/AZR/WB_SOURCETYPE',
    [PASchema.esWB_SourceTypeSTR]: '/AZR/WB_SOURCETYPESTR',
    [PASchema.esWB_UOM]: '/AZR/WB_UOM',
    [PASchema.esWB_Hierarchy_Level]: '/AZR/WB_HIERARCHYLR',
    [PASchema.esWB_Hierarchy_Period]: '/AZR/WB_HIERARCHYMPR',
    [PASchema.esWB_Hierarchy_SalesArea]: '/AZR/WB_HIERARCHYSR',
    [PASchema.esWB_Hierarchy]: '/AZR/WB_HIERARCHY',
    [PASchema.esWB_Hierarchy_Entity_Generation]: '/AZR/WB_HIERARCHYEGR',
    [PASchema.esWB_Hierarchy_Attribute_Generation]: '/AZR/WB_HIERARCHYAGR',
    [PASchema.esWB_Hierarchy_Intelligent_Key]: '/AZR/WB_HIERARCHYIKR',
    [PASchema.esWB_Hierarchy_Export]: '/AZR/WB_HIERARCHY_EXPORT',
    [PASchema.esWB_Hierarchy_MDScope]: '/AZR/WB_HIERARCHYSCR',
    [PASchema.esWB_Label_Type]: '/AZR/WB_LABELM',
    [PASchema.esWB_Label]: '/AZR/WB_LABEL',
    [PASchema.esWB_PolicyArea]: '/AZR/WB_POLICYAREA',
    [PASchema.esWB_Policy_Term_Type]: '/AZR/WB_POLICYTERMM',
    [PASchema.esWB_Policy]: '/AZR/WB_POLICY',
    [PASchema.esWB_Policy_SalesArea]: '/AZR/WB_POLICYSAR',
    [PASchema.esWB_Policy_FundType]: '/AZR/WB_POLICYFTR',
    [PASchema.esWB_Policy_Term]: '/AZR/WB_POLICYTERM',
    [PASchema.esWB_Policy_Procedure]: '/AZR/WB_POLICYPLR',
    [PASchema.esWB_Policy_Cube]: '/AZR/WB_POLICYCUBE',
    [PASchema.esWB_Policy_Cube_TermR]: '/AZR/WB_POLICYCUBETR',
    [PASchema.esWB_Policy_Cube_Process]: '/AZR/WB_POLICYCUBEPROCESS',
    [PASchema.esWB_Policy_Cube_ProcessR]: '/AZR/WB_POLICYCUBEPROCESSR',
    [PASchema.esWB_Policy_Term_Value]: '/AZR/WB_POLICYTERMVALUE',
    [PASchema.esWB_Tree]: '/AZR/WB_TREE',
    [PASchema.esWB_Tree_Folder]: '/AZR/WB_TREE_FOLDER',
    [PASchema.esWB_Product_Condition_Type_Text]: '/AZR/PROD_CNDMT',
    [PASchema.esWB_General_Ledger_Account_Text]: '/AZR/WB_GLACCTT',
    [PASchema.esWB_Product_Group_Text]: '/AZR/WB_PRDGRPT',
    [PASchema.esWB_Finished_Product_Text]: '/AZR/WB_PRODT',
    [PASchema.esWB_UOM_Text]: '/AZR/WB_UOMT',
    [PASchema.esWB_Product_Hierarchy_Text]: '/AZR/WB_PRDHT',
    [PASchema.esWB_Customer_Hierarchy_Text]: '/AZR/WB_CUSTHT',
    [PASchema.esWB_CustomerCR]: '/AZR/WB_CUSTCR',
    [PASchema.esWB_CustomerSAR]: '/AZR/WB_CUSTSAR',
    [PASchema.esWB_Policy_SpendType_TermR]: '/AZR/WB_POLICYSPENDTYPETERMR',
    [PASchema.esWB_Funding_Rule]: '/AZR/WB_FUNDINGRULE',
    [PASchema.esWB_Funding_Rule_Set]: '/AZR/WB_FUNDINGRULESET',
    [PASchema.esWB_Funding_Rule_Set_Relationship]: '/AZR/WB_FUNDINGRULESETR',
    [PASchema.esWB_External_Product_RelationShip]: '/AZR/WB_EXTPRDR'
})

// TODO: Complete logical keys for metadata export
_.defaults(dctLogicalKeysByEntitySet, {
    [PASchema.esWB_Source]: ["WB_MDSET_ID", "SOURCE_ID"],
    [PASchema.esWB_Set]: ["WB_MDSET_ID", "SET_ID", "SET_TYPE"],
    [PASchema.esWB_Source_SetType]: ["WB_SOURCE_ID", "SET_TYPE", "INTEGRATION_ALGORITHMS"],
    [PASchema.esWB_DistribChannel]: ["WB_MDSET_ID", "DISTRIBCHANNEL_ID", "ENTERPRISE_SET_ID"],
    [PASchema.esWB_DistribChannel_Text]: ["WB_DISTRIBCHANNEL_ID", "LANGUAGE"],
    [PASchema.esWB_Company]: ["WB_MDSET_ID", "COMPANY_ID", "ENTERPRISE_SET_ID"],
    [PASchema.esWB_Company_Text]: ["WB_COMPANY_ID", "LANGUAGE"],
    [PASchema.esWB_SalesOrg]: ["WB_COMPANY_ID", "SALESORG_ID", "ENTERPRISE_SET_ID"],
    [PASchema.esWB_SalesOrg_Text]: ["WB_SALESORG_ID", "LANGUAGE"],
    [PASchema.esWB_SalesArea]: ["WB_SALESORG_ID", "SALESAREA_ID", "ENTERPRISE_SET_ID"],
    [PASchema.esWB_SalesArea_Text]: ["WB_SALESAREA_ID", "LANGUAGE"],
    [PASchema.esWB_SourceType]: ["SOURCE_TYPE_ID"],
    [PASchema.esWB_SourceTypeSTR]: ["WB_SOURCETYPE_ID", "SET_TYPE", "INTEGRATION_ALGORITHMS"],
    [PASchema.esWB_Currency]: ["CURRENCY_ID", "ENTERPRISE_SET_ID"],
    [PASchema.esWB_CurrencyT]: ["WB_CURRENCY_ID", "LANGUAGE"],
    [PASchema.esWB_Division]: ["DIVISION_ID", "ENTERPRISE_SET_ID"],
    [PASchema.esWB_Division_Text]: ["WB_DIVISION_ID", "LANGUAGE"],
    [PASchema.esWB_MasterData_Set]: ["MDSET_ID"],
    [PASchema.esWB_Customer_Hierarchy]: ["WB_CUST_HIER_ID", "SOURCE_ID"],
    [PASchema.esWB_Customer_Hierarchy_SalesArea]: [],
    [PASchema.esWB_Customer_Hierarchy_Level]: ["WB_CUSTH_ID"],
    [PASchema.esWB_Customer]: ["CUSTOMER_ID", "CUSTOMER_SET_ID", "SOURCE_ID"], // This one is tricky
    [PASchema.esWB_Customer_Relationship]: ["WB_CUST_ID", "WB_CUSTH_ID", "WB_CUST_ID_PRNT", "EFFECTIVE_START_DT"],
    [PASchema.esWB_Customer_Tag_Relationship]: ["WB_CUST_ID", "WB_TAG_ID", "EFFECTIVE_START_DT"],
    [PASchema.esWB_Customer_LogicalKey]: ["WB_CUST_ID", "KEY_ID"],
    [PASchema.esWB_Customer_External_Relationship]: [
        "WB_SALESORG_ID",
        "WB_SALESAREA_ID",
        "WB_CUST_ID_PLANNING",
        "WB_CUST_ID_SOURCE",
        "EFFECTIVE_START_DT"
    ],
    [PASchema.esWB_Customer_Role_Relationship]: [
        "WB_CUST_ID",
        "WB_SALESAREA_ID",
        "WB_CUSTROLE_ID",
        "EFFECTIVE_START_DT"
    ],
    [PASchema.esWB_Customer_Role_Customer_Relationship]: [
        "WB_CUST_ID",
        "WB_SALESAREA_ID",
        "WB_CUST_ID_REL",
        "WB_CUSTROLE_ID",
        "EFFECTIVE_START_DT"
    ],
    [PASchema.esWB_Customer_Proxy_Relationship]: ["WB_CUST_ID_SOURCE", "WB_CUST_ID_PROXY", "EFFECTIVE_START_DT"],
    [PASchema.esWB_Customer_Bill_To_Relationship]: ["PLANNING_ACCOUNT_ID", "SUBPLANNING_ACCOUNT_ID", "BILL_TO_ID", "SHIP_TO_ID"],
    [PASchema.esWB_Customer_Pay_To_Relationship]: ["WB_CUST_ID_PLANNING", "WB_CUST_ID_PAYTO"],
    [PASchema.esWB_Customer_Calendar]: ["WB_SALESORG_ID", "WB_CUST_ID", "RETAIL_CALENDAR_START", "EFFECTIVE_START_DT"],
    [PASchema.esWB_Customer_Product]: ["WB_CUST_ID", "WB_PROD_ID", "EFFECTIVE_START_DT"],
    [PASchema.esWB_Customer_Role]: [],
    [PASchema.esWB_Customer_Type]: [],
    [PASchema.esWB_Customer_SalesArea_Relationship]: [],
    [PASchema.esWB_Finished_Product]: ["PRODUCT_ID", "PRODUCT_SET_ID"],
    [PASchema.esWB_Finished_Product_Relationship]: [
        "WB_PROD_ID",
        "WB_PRDH_ID",
        "WB_PRDGRP_ID_PRNT",
        "EFFECTIVE_START_DT"
    ],
    [PASchema.esWB_Finished_Product_Tag_Relationship]: ["WB_PROD_ID", "WB_TAG_ID", "EFFECTIVE_START_DT"],
    [PASchema.esWB_Product_Group]: ["PRODUCT_GROUP_ID", "PRODUCT_GROUP_SET_ID"],
    [PASchema.esWB_Product_Group_Relationship]: [
        "WB_PRDGRP_ID",
        "WB_PRDH_ID",
        "WB_PRDGRP_ID_PRNT",
        "EFFECTIVE_START_DT"
    ],
    [PASchema.esWB_Product_Group_Tag_Relationship]: ["WB_PRDGRP_ID", "WB_TAG_ID", "EFFECTIVE_START_DT"],
    [PASchema.esWB_Product_Group_Attribute]: ["WB_PRDGRP_ID", "ATTRIBUTE_ID"],
    [PASchema.esWB_Product_Group_LogicalKey]: ["WB_PRDGRP_ID", "KEY_ID"],
    [PASchema.esWB_Product_Hierarchy]: ["WB_PRD_HIER_ID", "SOURCE_ID"],
    [PASchema.esWB_Product_Hierarchy_Level]: ["WB_PRDH_ID", "LEVEL_ID"],
    [PASchema.esWB_Product_BOM]: ["WB_PROD_ID", "WB_PROD_ID_COMP", "EFFECTIVE_START_DT"],
    [PASchema.esWB_Product_Type]: [],
    [PASchema.esWB_Product_UOM]: ["WB_PROD_ID", "PRODUCT_UOM", "EFFECTIVE_START_DT"],
    [PASchema.esWB_Consumer_Product_Alignment]: ["WB_PROD_ID", "CONSUMER_UPC", "EFFECTIVE_START_DT"],
    [PASchema.esWB_Consumer_Product_Customer_Alignment]: ["WB_PROD_ID", "CONSUMER_UPC", "EFFECTIVE_START_DT"], // Never a foreign key.
    [PASchema.esWB_Period]: ["PERIOD_ID", "WB_PERIODM_ID"],
    [PASchema.esWB_Period_Attribute]: ["WB_PERIOD_ID", "WB_ATTRIBUTEM_ID", "WB_SALESAREA_ID"],
    [PASchema.esWB_Period_Relationship]: ["WB_PERIOD_ID", "WB_PERIOD_ID_PRNT"],
    [PASchema.esWB_Period_Tag_Relationship]: ["WB_PERIOD_ID", "WB_TAG_ID"],
    [PASchema.esWB_Period_Type]: ["PERIOD_TYPE_ID"],
    [PASchema.esWB_Period_Hierarchy]: ["WB_PERIOD_HIER_ID", "SOURCE_ID"],
    [PASchema.esWB_Period_Hierarchy_Level]: ["WB_PERIODH_ID", "WB_PERIODM_ID"],
    [PASchema.esWB_Period_Hierarchy_Company_Relationship]: [],
    [PASchema.esWB_Period_Company_Relationship]: [],
    [PASchema.esWB_Consumption_Product_Group]: ["WB_CUST_ID_PLANNING", "WB_CUST_ID_SOURCE", "WB_PRDGRP_ID"],
    [PASchema.esWB_Consumption_Product]: ["CONSUMER_PRODUCT_ID"],
    [PASchema.esWB_Product_Attribute]: ["WB_PROD_ID", "WB_PRDGRP_ID", "WB_ATTRIBUTEM_ID", "WB_SALESAREA_ID"],
    [PASchema.esWB_Product_Attribute_Group]: ["ATTRIB_GROUP_ID"],
    [PASchema.esWB_Product_Attribute_Group_Relationship]: ["WB_PRDATTRGRP_ID", "ATTRIBUTE_ID"],
    [PASchema.esWB_Product_Attribute_Map]: ["ATTRIB_MAP_ID"],
    [PASchema.esWB_Product_Attribute_Map_External_Relationship]: ["SOURCE_ID", "ATTRIBUTE_ID"],
    [PASchema.esWB_Product_Attribute_Map_Value_Relationship]: ["WB_PRDATTRMAP_ID"],
    [PASchema.esWB_Customer_Distribution_Relationship]: ["WB_CUST_ID", "WB_PRDGRP_ID"],
    [PASchema.esWB_Product_Group_UOM]: ["WB_PRDGRP_ID"],
    [PASchema.esWB_UOM]: ["UOM_ID"],
    [PASchema.esWB_Hierarchy_SalesArea]: ["WB_SALESAREA_ID", "WB_HIERARCHY_ID"],
    [PASchema.esWB_Hierarchy_Period]: ["WB_HIERARCHY_ID", "PERIOD_START_DT", "PERIOD_END_DT"],
    [PASchema.esWB_Hierarchy_Level]: ["WB_HIERARCHY_ID", "WB_ENTITY_ID", "WB_ATTRIBUTEM_ID", "LEVEL_ID"],
    [PASchema.esWB_Hierarchy]: ["HIERARCHY_ID", "WB_MDSET_ID", "ENTITY_DIMENSION"],
    [PASchema.esWB_Hierarchy_Attribute_Generation]: [],
    [PASchema.esWB_Hierarchy_Entity_Generation]: [],
    [PASchema.esWB_Hierarchy_Intelligent_Key]: [],
    [PASchema.esWB_Hierarchy_Export]: [],
    [PASchema.esWB_Hierarchy_MDScope]: [],
    [PASchema.esWB_PolicyArea]: ["POLICYAREA_ID"],
    [PASchema.esWB_Policy_Term_Type]: ["WB_POLICYAREA_ID", "TYPE_NAME"],
    [PASchema.esWB_Policy]: ["WB_POLICYAREA_ID", "WB_MDSET_ID", "WB_SALESORG_ID"],
    [PASchema.esWB_Policy_SalesArea]: ["WB_POLICY_ID", "WB_SALESAREA_ID"],
    [PASchema.esWB_Policy_FundType]: ["WB_POLICY_ID", "WB_FUNDTYPE_ID"],
    [PASchema.esWB_Policy_Procedure]: ["WB_POLICY_ID", "WB_POLICYTERM_ID"],
    [PASchema.esWB_Policy_Cube]: ["WB_POLICY_ID"],
    [PASchema.esWB_Policy_Cube_TermR]: ["WB_POLICYCUBE_ID", "WB_POLICYTERM_ID"],
    [PASchema.esWB_Policy_Cube_Process]: ["PROCESS_ID"],
    [PASchema.esWB_Policy_Cube_ProcessR]: [
        "WB_POLICYCUBEPROCESS_ID",
        "WB_CUST_ID_SRC",
        "WB_CUST_ID_TGT",
        "WB_PRD_ID_SRC",
        "WB_PRD_ID_TGT",
        "WB_PERIOD_ID_SRC",
        "WB_PERIOD_ID_TGT"
    ],
    [PASchema.esWB_Policy_Term_Value]: [],
    [PASchema.esWB_Product_Condition_Type_Text]: [],
    [PASchema.esWB_General_Ledger_Account_Text]: [],
    [PASchema.esWB_Product_Group_Text]: [],
    [PASchema.esWB_Finished_Product_Text]: [],
    [PASchema.esWB_UOM_Text]: [],
    [PASchema.esWB_Product_Hierarchy_Text]: [],
    [PASchema.esWB_Customer_Hierarchy_Text]: [],
    [PASchema.esWB_CustomerCR]: [],
    [PASchema.esWB_CustomerSAR]: [],
    [PASchema.esWB_Policy_SpendType_TermR]: ["WB_POLICY_ID"],
    [PASchema.esWB_Funding_Rule]: ["FUNDING_RULE_ID"],
    [PASchema.esWB_Funding_Rule_Set]: ["WB_FUNDINGRULE_ID", "RULE_TYPE", "ACTIVE_IND"],
    [PASchema.esWB_Funding_Rule_Set_Relationship]: ["PARTITION", "WB_FUNDINGACCOUNT_ID", "WB_FUNDINGRULESET_ID"],
    [PASchema.esWB_External_Product_RelationShip]: ["SOURCE_ID", "EXTERNAL_PRODUCT_ID"],
})

//maps tables to foreign keys that aren't part of JSDataRels for dataexporter/importer
//TODO: Fill out foreign key references that aren't part of the natural key
_.defaults(dctNonParentForeignKeysByEntitySet, {
    [PASchema.esWB_Set]: {},
    [PASchema.esWB_Customer]: { ["WB_SOURCE_ID"]: PASchema.esWB_Source, ["WB_FK_ROW_ID"]: PASchema.esWB_Customer },
    [PASchema.esWB_Customer_Relationship]: {
        ["WB_CUSTH_ID"]: PASchema.esWB_Customer_Hierarchy,
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_PRNT"]: PASchema.esWB_Customer
    },
    [PASchema.esWB_Customer_Tag_Relationship]: {
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_TAG_ID"]: PASchema.esWB_Tag
    },
    [PASchema.esWB_Customer_External_Relationship]: {
        ["WB_CUST_ID_SOURCE"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_SALESORG_ID"]: PASchema.esWB_SalesOrg,
        ["WB_SALESAREA_ID"]: PASchema.esWB_SalesArea
    },
    [PASchema.esWB_Customer_Proxy_Relationship]: {
        ["WB_CUST_ID_SOURCE"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer
    },
    [PASchema.esWB_Customer_Bill_To_Relationship]: {
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_SUBPLANNING"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_BILLTO"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_SHIPTO"]: PASchema.esWB_Customer
    },
    [PASchema.esWB_Customer_Pay_To_Relationship]: {
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_PAYTO"]: PASchema.esWB_Customer
    },
    [PASchema.esWB_Customer_Calendar]: {
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_SALESORG_ID"]: PASchema.esWB_SalesOrg
    },
    [PASchema.esWB_Customer_Product]: {
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product,
        ["WB_SOURCE_ID"]: PASchema.esWB_Source
    },
    [PASchema.esWB_Finished_Product]: {
        ["WB_PROD_TYPE_ID"]: PASchema.esWB_Finished_Product,
        ["WB_PROD_ID_CNSPRD_UPC"]: PASchema.esWB_Finished_Product
    },
    [PASchema.esWB_Customer_Role]: {},
    [PASchema.esWB_Customer_Type]: {},
    [PASchema.esWB_Customer_LogicalKey]: {
        ["VALUE_WB_ENTITY_ID"]: PASchema.esWB_Entity,
        ["VALUE_WB_ATTRIBUTEM_ID"]: PASchema.esWB_AttributeType
    },
    [PASchema.esWB_Customer_SalesArea_Relationship]: {},
    [PASchema.esWB_Finished_Product_Relationship]: {
        ["WB_PRDH_ID"]: PASchema.esWB_Product_Hierarchy,
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product,
        ["WB_PRDGRP_ID_PRNT"]: PASchema.esWB_Product_Group
    },
    [PASchema.esWB_Finished_Product_Tag_Relationship]: {
        ["WB_TAG_ID"]: PASchema.esWB_Tag,
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product
    },
    [PASchema.esWB_Product_Group]: {},
    [PASchema.esWB_Product_Group_LogicalKey]: {
        ["VALUE_WB_ENTITY_ID"]: PASchema.esWB_Entity,
        ["VALUE_WB_ATTRIBUTEM_ID"]: PASchema.esWB_AttributeType
    },
    [PASchema.esWB_Product_Group_Relationship]: {
        ["WB_PRDH_ID"]: PASchema.esWB_Product_Hierarchy,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_PRDGRP_ID_PRNT"]: PASchema.esWB_Product_Group
    },
    [PASchema.esWB_Product_Group_Tag_Relationship]: {
        ["WB_TAG_ID"]: PASchema.esWB_Tag,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group
    },
    [PASchema.esWB_Product_Group_Attribute]: { ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group },
    [PASchema.esWB_Product_Hierarchy]: {
        ["WB_PRDH_ID_CPPG"]: PASchema.esWB_Product_Hierarchy
    },
    [PASchema.esWB_Product_BOM]: {
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product,
        ["WB_PROD_ID_COMP"]: PASchema.esWB_Finished_Product
    },
    [PASchema.esWB_Product_Type]: {},
    [PASchema.esWB_Product_UOM]: { ["WB_PROD_ID"]: PASchema.esWB_Finished_Product },
    [PASchema.esWB_UOM]: {},
    [PASchema.esWB_Consumer_Product_Alignment]: { ["WB_PROD_ID"]: PASchema.esWB_Finished_Product },
    [PASchema.esWB_Consumer_Product_Customer_Alignment]: { ["WB_PROD_ID"]: PASchema.esWB_Finished_Product },
    [PASchema.esWB_Period]: { ["WB_PERIODM_ID"]: PASchema.esWB_Period_Type },
    [PASchema.esWB_Period_Relationship]: {
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
        ["WB_PERIOD_ID_PRNT"]: PASchema.esWB_Period,
        ["WB_PERIODH_ID"]: PASchema.esWB_Period_Hierarchy
    },
    [PASchema.esWB_Period_Tag_Relationship]: {
        ["WB_PERIOD_ID"]: PASchema.esWB_Period,
        ["WB_TAG_ID"]: PASchema.esWB_Tag
    },
    [PASchema.esWB_Period_Type]: {},
    [PASchema.esWB_Period_Hierarchy_Level]: {
        ["WB_PERIODH_ID"]: PASchema.esWB_Period_Hierarchy,
        ["WB_PERIODM_ID"]: PASchema.esWB_Period_Type
    },
    [PASchema.esWB_Period_Hierarchy_Company_Relationship]: {},
    [PASchema.esWB_Period_Company_Relationship]: {},
    [PASchema.esWB_Source]: { ["WB_SOURCETYPE_ID"]: PASchema.esWB_SourceType },
    [PASchema.esWB_Source_SetType]: { ["WB_SET_ID"]: PASchema.esWB_Set },
    [PASchema.esWB_SourceType]: {},
    [PASchema.esWB_SourceTypeSTR]: {},
    [PASchema.esWB_Company]: { WB_CURRENCY_ID: PASchema.esWB_Currency, WB_PERIODH_ID: PASchema.esWB_Period_Hierarchy },
    [PASchema.esWB_SalesArea]: {
        WB_DIVISION_ID: PASchema.esWB_Division,
        WB_DISTRIBCHANNEL_ID: PASchema.esWB_DistribChannel
    },
    [PASchema.esWB_Consumption_Product_Group]: {
        ["WB_CUST_ID_PLANNING"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_SOURCE"]: PASchema.esWB_Customer,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group,
        ["WB_CNSPG_ID_PREV"]: PASchema.esWB_Consumption_Product_Group,
        ["WB_CNSPG_ID_NEXT"]: PASchema.esWB_Consumption_Product_Group
    },
    [PASchema.esWB_Consumption_Product]: {
        ["WB_CNSPG_ID"]: PASchema.esWB_Consumption_Product_Group,
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product
    },
    [PASchema.esWB_Product_Attribute]: {},
    [PASchema.esWB_Product_Attribute_Group]: {},
    [PASchema.esWB_Product_Attribute_Group_Relationship]: {
        ["WB_PRDATTRGRP_ID"]: PASchema.esWB_Product_Attribute_Group
    },
    [PASchema.esWB_Product_Attribute_Map]: {},
    [PASchema.esWB_Product_Attribute_Map_External_Relationship]: {
        ["WB_PRDATTRMAP_ID"]: PASchema.esWB_Product_Attribute_Map
    },
    [PASchema.esWB_Product_Attribute_Map_Value_Relationship]: {
        ["WB_PRDATTRMAP_ID"]: PASchema.esWB_Product_Attribute_Map
    },
    [PASchema.esWB_Customer_Distribution_Relationship]: {
        ["WB_CUST_ID"]: PASchema.esWB_Customer,
        ["WB_CUST_ID_REL"]: PASchema.esWB_Customer,
        ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group
    },
    [PASchema.esWB_Product_Group_UOM]: { ["WB_PRDGRP_ID"]: PASchema.esWB_Product_Group },
    [PASchema.esWB_Hierarchy]: {
        ["WB_MDSET_ID"]: PASchema.esWB_MasterData_Set,
        ["WB_SCHEDULE_ID"]: PASchema.esWB_Schedule
    },
    [PASchema.esWB_Hierarchy_Level]: {
        ["WB_HIERARCHY_ID"]: PASchema.esWB_Hierarchy,
        ["WB_ENITYT_ID"]: PASchema.esWB_Entity,
        ["WB_ATTRIBUTEM_ID"]: PASchema.esWB_AttributeType
    },
    [PASchema.esWB_Hierarchy_Period]: { ["WB_HIERARCHY_ID"]: PASchema.esWB_Hierarchy },
    [PASchema.esWB_Hierarchy_SalesArea]: {
        ["WB_HIERARCHY_ID"]: PASchema.esWB_Hierarchy,
        ["WB_SALESAREA_ID"]: PASchema.esWB_SalesArea
    },
    [PASchema.esWB_Hierarchy_Export]: { ["WB_HIERARCHY_ID"]: PASchema.esWB_Hierarchy },
    [PASchema.esWB_Hierarchy_MDScope]: { ["WB_HIERARCHY_ID"]: PASchema.esWB_Hierarchy },
    [PASchema.esWB_PolicyArea]: {},
    [PASchema.esWB_Policy_Term_Type]: {},
    [PASchema.esWB_Policy]: {},
    [PASchema.esWB_Policy_SalesArea]: {},
    [PASchema.esWB_Policy_Term]: {},
    [PASchema.esWB_Policy_Procedure]: {},
    [PASchema.esWB_Policy_Cube]: {},
    [PASchema.esWB_Policy_Cube_TermR]: {},
    [PASchema.esWB_Policy_Cube_Process]: {},
    [PASchema.esWB_Policy_Term_Value]: {},
    [PASchema.esWB_Tree_Folder]: {
        ["WB_TREE_FOLDER_ID_PRNT"]: PASchema.esWB_Tree_Folder
    },
    [PASchema.esWB_Product_Condition_Type_Text]: {},
    [PASchema.esWB_General_Ledger_Account_Text]: {},
    [PASchema.esWB_Product_Group_Text]: {},
    [PASchema.esWB_Finished_Product_Text]: {},
    [PASchema.esWB_UOM_Text]: {},
    [PASchema.esWB_Product_Hierarchy_Text]: {},
    [PASchema.esWB_Customer_Hierarchy_Text]: {},
    [PASchema.esWB_CustomerCR]: {},
    [PASchema.esWB_CustomerSAR]: {},
    [PASchema.esWB_Policy_SpendType_TermR]: {},
    [PASchema.esWB_Funding_Rule]: {
        ["WB_SALESORG_ID"]: PASchema.esWB_SalesOrg,
        ["WB_MDSET_ID"]: PASchema.esWB_MasterData_Set,
        ["WB_FUNDINGACCOUNT_ID"]: PASchema.esWB_Funding_Account,
        ["WB_FUNDTYPE_ID"]: PASchema.esWB_Fund_Type,
        ["WB_AUTHUSR_ID_CREATEDBY"]: PASchema.esWB_User
    },
    [PASchema.esWB_Funding_Rule_Set]: {
        ["WB_FUNDINGRULE_ID"]: PASchema.esWB_Funding_Rule,
        ["WB_AUTHUSR_ID_LASTMODIFIED"]: PASchema.esWB_User
    },
    [PASchema.esWB_Funding_Rule_Set_Relationship]: {
        ["WB_FUNDINGACCOUNT_ID"]: PASchema.esWB_Funding_Account,
        ["WB_FUNDINGRULESET_ID"]: PASchema.esWB_Funding_Rule_Set
    },
    [PASchema.esWB_External_Product_RelationShip]: {
        ["WB_PROD_ID"]: PASchema.esWB_Finished_Product
    },
})

//some tables will share sequences. if that's the case, define the shared sequences here.
const productKeyGenSpecs: IKeyGeneratorSpecs = { sequence_name: "/AZR/WB_PROD_SEQ", ...KeyGenSpecs_default }
const productRelkeyGenSpecs: IKeyGeneratorSpecs = { sequence_name: "/AZR/WB_PRODR_SEQ", ...KeyGenSpecs_default }

_.defaults(dctMapperToKeyGenSpecs, {
    [PASchema.esWB_Company]: { sequence_name: '/AZR/WB_COMPANY_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Company_Text]: { sequence_name: '/AZR/WB_COMPANYT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Consumption_Product_Group]: { sequence_name: '/AZR/WB_CNSPG_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Consumption_Product]: { sequence_name: '/AZR/WB_CNSPRD_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer]: { sequence_name: '/AZR/WB_CUST_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Attribute]: { sequence_name: '/AZR/WB_CUSTATTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Bill_To_Relationship]: { sequence_name: '/AZR/WB_CUST_BILL_TO_REL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Pay_To_Relationship]: { sequence_name: '/AZR/WB_CUST_PAY_TO_REL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_LogicalKey]: { sequence_name: '/AZR/WB_CUSTLKR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Calendar]: { sequence_name: '/AZR/WB_CUSTCAL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Hierarchy]: { sequence_name: '/AZR/WB_CUSTH_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Hierarchy_SalesArea]: { sequence_name: '/AZR/WB_CUSTHSR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Hierarchy_Level]: { sequence_name: '/AZR/WB_CUSTH_LEVEL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Product]: { sequence_name: '/AZR/WB_CUSTPRDR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Relationship]: { sequence_name: '/AZR/WB_CUSTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Tag_Relationship]: { sequence_name: '/AZR/WB_CUST_TAGR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Distribution_Relationship]: {
        sequence_name: '/AZR/WB_CUSTRPG_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Customer_Role]: { sequence_name: '/AZR/WB_CUSTROLE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Type]: { sequence_name: '/AZR/WB_CUSTM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_SalesArea_Relationship]: { sequence_name: '/AZR/WB_CUSTSR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Role_Relationship]: { sequence_name: '/AZR/WB_CUSTRSR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Role_Customer_Relationship]: {
        sequence_name: '/AZR/WB_CUSTRSCR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Currency]: { sequence_name: '/AZR/WB_CURRENCY_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_CurrencyT]: { sequence_name: '/AZR/WB_CURRENCYT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Division]: { sequence_name: '/AZR/WB_DIVISION_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Division_Text]: { sequence_name: '/AZR/WB_DIVISIONT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_DistribChannel]: { sequence_name: '/AZR/WB_DISTRIBCHANNEL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_DistribChannel_Text]: { sequence_name: '/AZR/WB_DISTRIBCHANNELT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Proxy_Relationship]: { sequence_name: '/AZR/WB_EXTCUSTP_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_External_Relationship]: { sequence_name: '/AZR/WB_EXTCUSTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_MasterData_Set]: { sequence_name: '/AZR/WB_MDSET_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Period]: { sequence_name: '/AZR/WB_PERIOD_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Period_Attribute]: { sequence_name: '/AZR/WB_PERIODATTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Period_Hierarchy]: { sequence_name: '/AZR/WB_PERIODH_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Period_Hierarchy_Level]: { sequence_name: '/AZR/WB_PERIODH_LEVEL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Period_Type]: { sequence_name: '/AZR/WB_PERIODM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Period_Relationship]: { sequence_name: '/AZR/WB_PERIODR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Period_Tag_Relationship]: { sequence_name: '/AZR/WB_PERIOD_TAGR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Period_Hierarchy_Company_Relationship]: {
        sequence_name: '/AZR/WB_PERIODHCR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Period_Company_Relationship]: { sequence_name: '/AZR/WB_PERIODCR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Attribute]: { sequence_name: '/AZR/WB_PRDATTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Attribute_Group]: { sequence_name: '/AZR/WB_PRDATTRGRP_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Attribute_Group_Relationship]: {
        sequence_name: '/AZR/WB_PRDATTRGRPR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Product_Attribute_Map]: { sequence_name: '/AZR/WB_PRDATTRMAP_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Attribute_Map_External_Relationship]: {
        sequence_name: '/AZR/WB_PRDATTRMAP_EXTR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Product_Attribute_Map_Value_Relationship]: {
        sequence_name: '/AZR/WB_PRDATTRMAP_VALUER_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Product_Group]: productKeyGenSpecs,
    [PASchema.esWB_Product_Group_Attribute]: { sequence_name: '/AZR/WB_PRDGRPAR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Group_SalesArea]: { sequence_name: '/AZR/WB_PRDGRPSR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Group_LogicalKey]: { sequence_name: '/AZR/WB_PRDGRPLKR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Group_Tag_Relationship]: {
        sequence_name: '/AZR/WB_PRDGRP_TAGR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Product_Group_Relationship]: productRelkeyGenSpecs,
    [PASchema.esWB_Product_Group_UOM]: { sequence_name: '/AZR/WB_PRDGRP_UOM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Group_External_Relationship]: {
        sequence_name: '/AZR/WB_PRDGRP_EXTR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Product_Hierarchy]: { sequence_name: '/AZR/WB_PRDH_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Hierarchy_SalesArea]: { sequence_name: '/AZR/WB_PRDHSR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Hierarchy_Level]: { sequence_name: '/AZR/WB_PRDH_LEVEL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Finished_Product]: productKeyGenSpecs,
    [PASchema.esWB_Finished_Product_Relationship]: productRelkeyGenSpecs,
    [PASchema.esWB_Finished_Product_SalesArea]: { sequence_name: '/AZR/WB_PRODSR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Finished_Product_Tag_Relationship]: {
        sequence_name: '/AZR/WB_PROD_TAGR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Product_BOM]: { sequence_name: '/AZR/WB_PROD_BOM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_BOM_Component]: { sequence_name: '/AZR/WB_PROD_BOM_COMP_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Type]: { sequence_name: '/AZR/WB_PRDM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_UOM]: { sequence_name: '/AZR/WB_PROD_UOM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_SalesOrg]: { sequence_name: '/AZR/WB_SALESORG_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_SalesOrg_Text]: { sequence_name: '/AZR/WB_SALESORGT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_SalesArea]: { sequence_name: '/AZR/WB_SALESAREA_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_SalesArea_Text]: { sequence_name: '/AZR/WB_SALESAREAT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Set]: { sequence_name: '/AZR/WB_SET_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_SourceType]: { sequence_name: '/AZR/WB_SOURCETYPE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_SourceTypeSTR]: { sequence_name: '/AZR/WB_SOURCETYPESTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Source]: { sequence_name: '/AZR/SOURCE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Source_SetType]: { sequence_name: '/AZR/SOURCESR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Consumer_Product_Customer_Alignment]: {
        sequence_name: '/AZR/WB_UPCPRDPR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Consumer_Product_Alignment]: { sequence_name: '/AZR/WB_UPCPRDR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_UOM]: { sequence_name: '/AZR/WB_UOM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Hierarchy]: { sequence_name: '/AZR/WB_HIERARCHY_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Hierarchy_Level]: { sequence_name: '/AZR/WB_HIERARCHYLR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Hierarchy_Period]: { sequence_name: '/AZR/WB_HIERARCHYMPR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Hierarchy_SalesArea]: { sequence_name: '/AZR/WB_HIERARCHYSR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Hierarchy_Entity_Generation]: { sequence_name: '/AZR/WB_HIERARCHYEGR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Hierarchy_Attribute_Generation]: {
        sequence_name: '/AZR/WB_HIERARCHYAGR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Hierarchy_Intelligent_Key]: { sequence_name: '/AZR/WB_HIERARCHYIKR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Hierarchy_Export]: { sequence_name: '/AZR/WB_HIERARCHY_EXPORT_SEQ', ...KeyGenSpecs_Poolsize_500 },
    [PASchema.esWB_Hierarchy_MDScope]: { sequence_name: '/AZR/WB_HIERARCHYSCR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Label_Type]: { sequence_name: '/AZR/WB_LABELM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Label]: { sequence_name: '/AZR/WB_LABEL_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_PolicyArea]: { sequence_name: '/AZR/WB_POLICYAREA_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy_Term_Type]: { sequence_name: '/AZR/WB_POLICYTERMM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy]: { sequence_name: '/AZR/WB_POLICY_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy_SalesArea]: { sequence_name: '/AZR/WB_POLICYSAR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy_FundType]: { sequence_name: '/AZR/WB_POLICYFTR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy_Term]: { sequence_name: '/AZR/WB_POLICYTERM_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy_Procedure]: { sequence_name: '/AZR/WB_POLICYPLR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy_Cube]: { sequence_name: '/AZR/WB_POLICYCUBE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy_Cube_TermR]: { sequence_name: '/AZR/WB_POLICYCUBETR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy_Cube_Process]: { sequence_name: '/AZR/WB_POLICYCUBEPROCESS_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy_Cube_ProcessR]: { sequence_name: '/AZR/WB_POLICYCUBEPROCESSR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy_Term_Value]: { sequence_name: '/AZR/WB_POLICYTERMVALUE_SEQ', ...KeyGenSpecs_Poolsize_500 },
    [PASchema.esWB_Tree]: { sequence_name: '/AZR/WB_TREE_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Tree_Folder]: { sequence_name: '/AZR/WB_TREEFOLDER_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Condition_Type_Text]: { sequence_name: '/AZR/PROD_CNDMT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_General_Ledger_Account_Text]: { sequence_name: '/AZR/WB_GLACCTT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Group_Text]: { sequence_name: '/AZR/WB_PRDGRPT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Finished_Product_Text]: { sequence_name: '/AZR/WB_PRODT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_UOM_Text]: { sequence_name: '/AZR/WB_UOMT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Product_Hierarchy_Text]: { sequence_name: '/AZR/WB_PRDHT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Customer_Hierarchy_Text]: { sequence_name: '/AZR/WB_CUSTHT_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_CustomerCR]: { sequence_name: '/AZR/WB_CUSTCR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_CustomerSAR]: { sequence_name: '/AZR/WB_CUSTSAR_SEQ', ...KeyGenSpecs_default },
    [PASchema.esWB_Policy_SpendType_TermR]: {
        sequence_name: '/AZR/WB_POLICYSPENDTYPETERMR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Funding_Rule]: {
        sequence_name: '/AZR/WB_FUNDINGRULE_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Funding_Rule_Set]: {
        sequence_name: '/AZR/WB_FUNDINGRULESET_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_Funding_Rule_Set_Relationship]: {
        sequence_name: '/AZR/WB_FUNDINGRULESETR_SEQ',
        ...KeyGenSpecs_default
    },
    [PASchema.esWB_External_Product_RelationShip]: {
        sequence_name: '/AZR/WB_EXTPRDR_SEQ',
        ...KeyGenSpecs_default
    }
})
